var _defs, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _path4, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchoolLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 605.354,
    height: 573.959,
    viewBox: "0 0 605.354 573.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff8e3;}.b,.g,.k,.o,.t{fill:#040405;}.b,.l{opacity:0.1;}.c{isolation:isolate;}.d{fill:#ececec;}.e{fill:#f2f2f2;}.f{fill:#d8d8d8;}.g,.p,.u{opacity:0.2;}.h{fill:#e7e6e6;}.i{fill:#1c262b;}.j{fill:#354952;}.am,.k,.r{opacity:0.3;}.ae,.l,.m,.q,.r,.u{fill:#fff;}.m{opacity:0.6;}.n{fill:#2d973d;}.ae,.al,.o{opacity:0.4;}.s{opacity:0.15;}.v{fill:#29373e;}.w{fill:#946708;}.x{fill:#e0c99e;}.y{fill:#cbab65;}.z{fill:#ab8948;}.aa{fill:#ef9296;}.ab{fill:#915612;}.ac{fill:#8d610a;}.ad{fill:#142429;}.af{fill:#ec797c;}.ag{fill:#8c569b;}.ah{fill:#db8000;}.ai{fill:#91570a;}.aj{fill:#fb9b00;}.ak{fill:#ffd28c;}.an{fill:#3c2c17;}.ao{fill:#565656;}.ap{fill:#1a1a1a;}.aq{fill:#d9100d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M529.077,363.193c-118.585-68.465-310.223-68.464-428.037,0s-117.2,179.474,1.388,247.939,310.231,68.469,428.052,0S647.67,431.663,529.077,363.193Z",
    transform: "translate(-13.08 -88.528)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M185.046,582.167l106.607-61.576L376.744,569.6a55.816,55.816,0,0,1,15.173-12.359c30.351-17.523,79.4-17.522,109.552,0s30,45.935-.355,63.458a91.434,91.434,0,0,1-20.763,8.571l8.553,4.926a3.868,3.868,0,0,1,0,6.7L390.03,698.009a15.476,15.476,0,0,1-15.462.009L185.05,588.869A3.868,3.868,0,0,1,185.046,582.167Z",
    transform: "translate(-50.034 -133.896)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M48.653,544.291l4.823,2.785a8.411,8.411,0,0,0,8.411,0L356.369,377.056a2.073,2.073,0,0,0,0-3.59l-4.758-2.747a8.415,8.415,0,0,0-8.411,0L48.653,540.7A2.073,2.073,0,0,0,48.653,544.291Z",
    transform: "translate(-20.586 -101.079)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(416.846 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.049 10.408)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M553.714,42.86l5.24-3.045-.307,118.627-5.24,3.045Z",
    transform: "translate(-553.406 -39.815)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.049 129.035)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M553.406,194.428l5.24-3.045L709.781,278.64l-5.24,3.045Z",
    transform: "translate(-553.406 -191.382)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.045)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M546.025,30.407l163.192,94.219-.347,132.482L545.678,162.889ZM702.861,246.7l.308-118.627L552.034,40.816l-.308,118.626L702.861,246.7",
    transform: "translate(-545.678 -30.407)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.347)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M546.121,29.561l5.24-3.045,163.192,94.219-5.24,3.045Z",
    transform: "translate(-546.121 -26.516)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163.192 94.219)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M754.533,149.944l5.24-3.045-.346,132.482-5.24,3.045Z",
    transform: "translate(-754.186 -146.898)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.597 55.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M646.407,97.226,646.1,215.853l6.029,3.481.307-118.627Z",
    transform: "translate(-646.1 -97.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M654.112,101.671h0L653.8,220.3l5.24-3.045.29-112.569Z",
    transform: "translate(-647.774 -98.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 0.003,
    height: 6.961,
    transform: "translate(0.308 0.002) rotate(-60.001)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M652.5,105.57l.014-4.864-6.029-3.481-.014,4.864,6.029,3.481Z",
    transform: "translate(-567.585 -41.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M654.178,106.537l4.228-2.434-4.212-2.432h0Z",
    transform: "translate(-569.259 -42.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 0.003,
    height: 6.961,
    transform: "translate(78.904 55.343) rotate(-60)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.357 157.062)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.416 48.579)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M459.98,289.261V389.443l170.4,97.861V387.122Z",
    transform: "translate(-459.98 -289.261)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M744.907,364.867V465.049L677.7,503.736V403.554Z",
    transform: "translate(-507.298 -305.693)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M459.98,289.261V389.443l170.4,97.861V387.122Z",
    transform: "translate(-457.564 -240.682)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M744.907,364.867V465.049L677.7,503.736V403.554Z",
    transform: "translate(-504.882 -257.114)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M456.893,266.435l174.37,100.153L699.334,327.4,524.863,227.192Z",
    transform: "translate(-456.893 -227.192)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M456.893,277.332v10.236l174.37,100.153V377.485Z",
    transform: "translate(-456.893 -238.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M747.754,355.231v10.236l-68.072,39.184V394.415Z",
    transform: "translate(-505.313 -255.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M747.754,355.231v10.236l-68.072,39.184V394.415Z",
    transform: "translate(-505.313 -255.019)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(486.772 205.264)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M671.514,360.175l38.139-22.222-36.492-21.207-38.139,22.222Z",
    transform: "translate(-635.022 -294.857)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.128 11.045)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M692.853,356.324,720,340.652l-5.037-2.927L692.837,350.5Z",
    transform: "translate(-651.714 -310.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M719.768,339.583l-27.145,15.673-.017-5.826,22.125-12.774,5.021-2.9,0-.95-27.974,16.151.022,7.726,27.975-16.151Z",
    transform: "translate(-651.484 -309.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M719.768,339.583l-27.145,15.673-.017-5.826,22.125-12.774,5.021-2.9,0-.95-27.974,16.151.022,7.726,27.975-16.151Z",
    transform: "translate(-651.484 -309.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M719.768,339.583l-27.145,15.673-.017-5.826,22.125-12.774,5.021-2.9,0-.95-27.974,16.151.022,7.726,27.975-16.151Z",
    transform: "translate(-651.484 -309.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M680.586,346.942,640.3,323.527l.022,7.726,40.29,23.414Z",
    transform: "translate(-640.296 -307.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M680.586,346.942,640.3,323.527l.022,7.726,40.29,23.414Z",
    transform: "translate(-640.296 -307.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M680.586,346.942,640.3,323.527l.022,7.726,40.29,23.414Z",
    transform: "translate(-640.296 -307.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M680.586,342.457l27.974-16.151-40.29-23.414L640.3,319.042Z",
    transform: "translate(-640.296 -302.891)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M680.586,342.457l27.974-16.151-40.29-23.414L640.3,319.042Z",
    transform: "translate(-640.296 -302.891)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M719.23,334.576v5.835L692.853,355.64l-.017-5.826Z",
    transform: "translate(-651.714 -309.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M719.23,334.576v5.835L692.853,355.64l-.017-5.826Z",
    transform: "translate(-651.714 -309.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M698.234,361.514l.586-2.111,2.013.61c-2.233-2.164-.643-4.873-3.254-6.329l-2.6,1.5C697.41,356.967,696.046,359,698.234,361.514Z",
    transform: "translate(-652.18 -313.93)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.195 5.194)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M669.927,309.764,652.4,319.885a.709.709,0,0,0,0,1.227l9.532,5.539a1.771,1.771,0,0,0,1.777,0l17.529-10.121a.709.709,0,0,0,0-1.227l-9.532-5.539A1.774,1.774,0,0,0,669.927,309.764Z",
    transform: "translate(-652.044 -309.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M688.108,319.153,668.63,330.4l1.532.89,19.478-11.246Z",
    transform: "translate(-655.649 -311.619)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M671.517,333.775l1.532.89,10.33-5.964-1.532-.89Z",
    transform: "translate(-656.276 -313.501)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M636.8,316.3h0l26.374-15.227,33.917,19.555,0,.818-26.02,15.022.024,8.321,0-1.476,24.375-14.154v-.366l1.649.974,0,.818-26.375,15.228a.247.247,0,0,1-.257.021v0l-33.908-19.55-.008-.005,0,0h0a.253.253,0,0,1-.1-.224l-.026-9.139A.779.779,0,0,1,636.8,316.3Z",
    transform: "translate(-635.33 -291.45)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.111 9.619)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M645.537,321.28h0l-.71-.409h0l-7.223-4.165h0l-.71-.409,26.375-15.227,33.916,19.555L670.81,335.852Z",
    transform: "translate(-636.54 -301.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M636.8,320.525h0l.71.409h0l7.223,4.165,0,0,.71.409h0l25.273,14.572a.779.779,0,0,0-.355.614l.026,9.139a.25.25,0,0,0,.1.225v0l-33.908-19.55-.008-.005,0,0h0a.253.253,0,0,1-.1-.224l-.026-9.139A.779.779,0,0,1,636.8,320.525Z",
    transform: "translate(-636.441 -305.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M679.775,341.9a.779.779,0,0,1,.355-.614l26.377-15.228,0,.818-26.02,15.022.024,8.321,26.02-15.022,0,.818-26.375,15.228a.247.247,0,0,1-.257.021.25.25,0,0,1-.1-.225Z",
    transform: "translate(-645.859 -306.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M645.537,321.28h0l-.71-.409h0l-7.223-4.165h0l-.71-.409,26.375-15.227,33.916,19.555L670.81,335.852Z",
    transform: "translate(-636.54 -301.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M636.8,320.525h0l.71.409h0l7.223,4.165,0,0,.71.409h0l25.273,14.572a.779.779,0,0,0-.355.614l.026,9.139a.25.25,0,0,0,.1.225v0l-33.908-19.55-.008-.005,0,0h0a.253.253,0,0,1-.1-.224l-.026-9.139A.779.779,0,0,1,636.8,320.525Z",
    transform: "translate(-636.441 -305.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M679.775,341.9a.779.779,0,0,1,.355-.614l26.377-15.228,0,.818-26.02,15.022.024,8.321,26.02-15.022,0,.818-26.375,15.228a.247.247,0,0,1-.257.021.25.25,0,0,1-.1-.225Z",
    transform: "translate(-645.859 -306.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M705.081,328.3v6.776l-24.375,14.153-.019-6.845Z",
    transform: "translate(-646.057 -306.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M705.081,328.3v6.776l-24.375,14.153-.019-6.845Z",
    transform: "translate(-646.057 -306.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M706.735,337.461l-1.649-.974v.366l-24.376,14.153,0,1.477Z",
    transform: "translate(-646.062 -308.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M706.735,337.461l-1.649-.974v.366l-24.376,14.153,0,1.477Z",
    transform: "translate(-646.062 -308.766)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.949 34.071)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M685.626,352.429l.586-2.11,2.013.61c-2.233-2.164-.643-4.872-3.254-6.328l-2.6,1.5C684.8,347.883,683.438,349.913,685.626,352.429Z",
    transform: "translate(-682.372 -344.601)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(35.949 34.071)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M685.626,352.429l.586-2.11,2.013.61c-2.233-2.164-.643-4.872-3.254-6.328l-2.6,1.5C684.8,347.883,683.438,349.913,685.626,352.429Z",
    transform: "translate(-682.372 -344.601)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.135)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M690.464,337.175,715.05,322.98l-4.562-2.651L690.448,331.9Z",
    transform: "translate(-653.203 -295.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M714.841,322.012l-24.586,14.195-.015-5.277,20.039-11.57,4.547-2.625,0-.861L689.486,330.5l.02,7,25.338-14.629Z",
    transform: "translate(-652.994 -294.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M714.841,322.012l-24.586,14.195-.015-5.277,20.039-11.57,4.547-2.625,0-.861L689.486,330.5l.02,7,25.338-14.629Z",
    transform: "translate(-652.994 -294.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M714.841,322.012l-24.586,14.195-.015-5.277,20.039-11.57,4.547-2.625,0-.861L689.486,330.5l.02,7,25.338-14.629Z",
    transform: "translate(-652.994 -294.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M679.352,328.677,642.86,307.47l.02,7,36.492,21.207Z",
    transform: "translate(-642.86 -292.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M679.352,328.677,642.86,307.47l.02,7,36.492,21.207Z",
    transform: "translate(-642.86 -292.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M679.352,328.677,642.86,307.47l.02,7,36.492,21.207Z",
    transform: "translate(-642.86 -292.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M679.352,324.614l25.337-14.629L668.2,288.779,642.86,303.408Z",
    transform: "translate(-642.86 -288.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M679.352,324.614l25.337-14.629L668.2,288.779,642.86,303.408Z",
    transform: "translate(-642.86 -288.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M714.353,317.477v5.285l-23.89,13.793-.015-5.277Z",
    transform: "translate(-653.203 -295.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M714.353,317.477v5.285l-23.89,13.793-.015-5.277Z",
    transform: "translate(-653.203 -295.016)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.329 4.704)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M669.7,295l-15.876,9.166a.643.643,0,0,0,0,1.112l8.633,5.017a1.608,1.608,0,0,0,1.61,0l15.876-9.166a.643.643,0,0,0,0-1.112l-8.634-5.017A1.608,1.608,0,0,0,669.7,295Z",
    transform: "translate(-653.502 -294.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M686.165,303.507l-17.642,10.186,1.388.806,17.642-10.186Z",
    transform: "translate(-656.766 -296.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M671.138,316.751l1.388.807,9.356-5.4-1.388-.807Z",
    transform: "translate(-657.335 -298.388)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M707.745,330.964l0-.95-.769-.446v-4.945l-4.269,2.464h0l5.021-2.9,0-.95-7.6-4.414,3.188-1.84,0-.861-.7-.4V311.24l-1.89,1.091,2.572-1.485,0-.86L666.8,288.779l-25.338,14.629.02,7,.442.257-5.13,2.962h0a.779.779,0,0,0-.355.614l.026,9.139a.253.253,0,0,0,.1.224h0l0,0,.008.005,33.908,19.55v0a.247.247,0,0,0,.257-.021l1.1-.633,7.933,4.61,4.351-2.512a6.14,6.14,0,0,0,1.39,2.8l.586-2.111,2.013.61a4.88,4.88,0,0,1-1.371-2.815Z",
    transform: "translate(-635.33 -288.779)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(507.318 299.538)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M729.792,561.2c-8.771-5.064-22.947-5.064-31.661,0s-8.669,13.276.1,18.34,22.946,5.064,31.661,0S738.565,566.261,729.792,561.2Z",
    transform: "translate(-667.869 -441.433)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.733 78.322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M735.522,525.019l-21.237.619-21.238-.619c-.915,14.342,1.885,28.958,5.746,36.1l.014,0a9.672,9.672,0,0,0,4.2,4.278c6.267,3.618,16.393,3.618,22.618,0a9.419,9.419,0,0,0,4.2-4.388C733.663,553.826,736.432,539.29,735.522,525.019Z",
    transform: "translate(-692.873 -512.718)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.174)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M729.3,512.905c8.321,4.8,8.365,12.592.1,17.4s-21.714,4.8-30.034,0-8.364-12.592-.1-17.4S720.98,508.1,729.3,512.905Z",
    transform: "translate(-693.096 -509.302)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.843 2.704)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M727.307,515.568c6.492,3.748,6.527,9.825.077,13.573s-16.939,3.748-23.431,0-6.526-9.824-.076-13.572S720.815,511.82,727.307,515.568Z",
    transform: "translate(-699.061 -512.757)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "translate(4.843 2.704)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M727.307,515.568c6.492,3.748,6.527,9.825.077,13.573s-16.939,3.748-23.431,0-6.526-9.824-.076-13.572S720.815,511.82,727.307,515.568Z",
    transform: "translate(-699.061 -512.757)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M752.839,409.231c-47.859,15.671-48.292,47.689-37.5,70.488,2.72,4.615,10.956,7.094,18.123-21.262l-12.571,1.612,14.65-7.425,3.805-11.374-12.214.907,15.5-6.521C748.345,418.377,752.839,409.231,752.839,409.231Z",
    transform: "translate(-671.778 -409.231)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M752.839,409.231c-47.859,15.671-48.292,47.689-37.5,70.488,2.72,4.615,10.956,7.094,18.123-21.262l-12.571,1.612,14.65-7.425,3.805-11.374-12.214.907,15.5-6.521C748.345,418.377,752.839,409.231,752.839,409.231Z",
    transform: "translate(-671.778 -409.231)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M752.839,409.231c-47.859,15.671-48.292,47.689-37.5,70.488,2.72,4.615,10.956,7.094,18.123-21.262l-12.571,1.612,14.65-7.425,3.805-11.374-12.214.907,15.5-6.521C748.345,418.377,752.839,409.231,752.839,409.231Z",
    transform: "translate(-671.778 -409.231)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M740.911,419.462c-25.238,19.155-27.517,41.116-20.387,64.042C718,463.317,715.276,442.9,740.911,419.462Z",
    transform: "translate(-673.386 -411.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M661.272,450.787c47.176,6.642,52.9,36.388,46.639,59.415-1.767,4.751-9.025,8.427-20.411-16.791l11.975-.588L684.6,488.342l-5.434-9.96,11.526-1.185-15.523-3.5C666.978,458.557,661.272,450.787,661.272,450.787Z",
    transform: "translate(-661.272 -418.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M661.272,450.787c47.176,6.642,52.9,36.388,46.639,59.415-1.767,4.751-9.025,8.427-20.411-16.791l11.975-.588L684.6,488.342l-5.434-9.96,11.526-1.185-15.523-3.5C666.978,458.557,661.272,450.787,661.272,450.787Z",
    transform: "translate(-661.272 -418.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M661.272,450.787c47.176,6.642,52.9,36.388,46.639,59.415-1.767,4.751-9.025,8.427-20.411-16.791l11.975-.588L684.6,488.342l-5.434-9.96,11.526-1.185-15.523-3.5C666.978,458.557,661.272,450.787,661.272,450.787Z",
    transform: "translate(-661.272 -418.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M679.08,457.44c26.687,13.647,32.458,33.72,29.627,56.257C707.7,494.477,706.849,475.014,679.08,457.44Z",
    transform: "translate(-665.142 -419.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M768.809,465.029c-43.263.708-51.751,26.878-48.686,48.332,1.06,4.48,7.19,8.605,20.276-12.849l-10.727-1.87,13.91-2.374,6.012-8.37-10.256-2.357,14.382-1.415A196.953,196.953,0,0,1,768.809,465.029Z",
    transform: "translate(-673.94 -421.358)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M756.526,469.033c-25.581,9.313-33.029,26.76-33,47.39C726.585,499.211,729.532,481.765,756.526,469.033Z",
    transform: "translate(-674.802 -422.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M768.809,465.029c-43.263.708-51.751,26.878-48.686,48.332,1.06,4.48,7.19,8.605,20.276-12.849l-10.727-1.87,13.91-2.374,6.012-8.37-10.256-2.357,14.382-1.415A196.953,196.953,0,0,1,768.809,465.029Z",
    transform: "translate(-673.94 -421.358)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(338.591 196.844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M581.088,599.248a12.882,12.882,0,0,0-4.7-9.25v-5.724l-30.574-18.161,16.121-4.064a11.738,11.738,0,0,0-1.716,5.73c.005,1.89.7,3.186,1.8,3.762l0,.008,3.621,2.308c.024.015.047.032.071.045l.008,0h0a4.116,4.116,0,0,0,4.078-.427,12.726,12.726,0,0,0,5.773-10,4.083,4.083,0,0,0-1.626-3.664l0,0-.046-.029c-.018-.01-.034-.023-.052-.033l-3.668-2.328-.006.01a3.369,3.369,0,0,0-2.731-.265v-.924l-1.965-.664-26.191,1.378v-4.627c.278-.125.566-.24.822-.387,1.72-.993,2.587-2.3,2.6-3.6V518.057H525.126v30.292c-.008,1.3.842,2.606,2.554,3.6a9.409,9.409,0,0,0,.863.409v3.888l-18.933-4.09-.907.363V556c-.011.006-.024.011-.035.018l-.006-.011-3.669,2.329c-.016.009-.03.02-.045.028l-.052.033v0a4.083,4.083,0,0,0-1.624,3.663,12.509,12.509,0,0,0,2.853,7.372l-18.29,8.241V582a6.682,6.682,0,0,0-.756.373,12.719,12.719,0,0,0-5.773,9.993c.005,1.889.7,3.185,1.8,3.761l0,.009,3.617,2.3c.027.016.051.034.077.05l.006,0h0a4.113,4.113,0,0,0,4.077-.427,12.721,12.721,0,0,0,5.773-10,4.082,4.082,0,0,0-1.625-3.663l0,0-.052-.032c-.016-.009-.03-.02-.046-.03l-1.066-.676,34.674-14.092a2.526,2.526,0,0,0,1.305,2.019l-3.124,27.269v3.7a12.872,12.872,0,0,0-4.777,9.3c.005,1.889.7,3.185,1.8,3.761l0,.009,3.625,2.31c.023.014.045.03.068.043l.009.005v0a4.109,4.109,0,0,0,4.076-.427,12.721,12.721,0,0,0,5.773-10,4.079,4.079,0,0,0-1.625-3.663l0,0-.049-.031c-.017-.01-.032-.022-.049-.031l-3.668-2.328-.006.011a3.091,3.091,0,0,0-1.922-.42l3.994-28.418v0a8.553,8.553,0,0,0,2.531-.4v0l32.842,17.743-1.89,1.2c-.017.009-.033.021-.05.031l-.048.031v0a4.082,4.082,0,0,0-1.625,3.663,12.726,12.726,0,0,0,5.773,10,4.115,4.115,0,0,0,4.077.427h0l.007,0c.025-.015.049-.032.074-.048l3.62-2.306,0-.008C580.385,602.435,581.082,601.138,581.088,599.248Zm-63.64-37.561,2.682,1.438-1.852.834A12.7,12.7,0,0,0,517.448,561.687Zm-23.434,14.895,13.249-5.9h0l-17.91,7.98Zm24.551-10.938h0l9.978-4.446Z",
    transform: "translate(-453.433 -330.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M634.214,323.564a7.045,7.045,0,0,0-1.109-1.872,14.7,14.7,0,0,0-1.524-1.59,29.066,29.066,0,0,0-2.5-2.026,29.763,29.763,0,0,0-3.041-1.953,30.817,30.817,0,0,0-4.888-2.215q-.959-.335-1.939-.608t-1.976-.484c-22.763-11.245-69.261-31.389-69.261-31.389-17.254-7.147-22.564-1.43-26.239,2.451-2.757,2.91-4.366,8.807-4.308,17.173a79.8,79.8,0,0,0,.632,9.171c.715,5.807,2.216,15.568,2.531,25.837a103.613,103.613,0,0,1-.207,11.041c-.728,9.466-3.087,18.31-8.656,23.775-8.234,8.082-33.54,3.3-45.836.356l-.17-.04c-3.44-.827-5.811-1.495-6.474-1.686l-.125-.035-.083-.024c-6.02-3.3-13.632-.2-12.938,5.951a8.056,8.056,0,0,0,.275,1.334c.045.154.093.31.148.466a12.528,12.528,0,0,0,1.618,3.071c3.433,4.882,6.02,6.522,7.69,10.5.2.468.38.968.551,1.511,1.111,3.521,1.682,8.793,1.679,18.31l-6.579,3.376a9.837,9.837,0,0,0-3.341,3.229,16.2,16.2,0,0,0-2.448,8.294,17.621,17.621,0,0,0,.438,4.519q.17.736.409,1.448a12.133,12.133,0,0,0,5.4,6.864l71.629,38.047a16.756,16.756,0,0,0,15.432.15L589.19,451.1a25.405,25.405,0,0,0,13.045-16.028l28.73-106.14a4.031,4.031,0,0,0,2.73-1.229,3.476,3.476,0,0,0,.82-1.97,4.3,4.3,0,0,0,.021-.55A4.849,4.849,0,0,0,634.214,323.564ZM532.563,310.986c.056-.333.124-.658.183-.988.114-.643.229-1.285.355-1.921-.113.567-.214,1.143-.317,1.716-.072.4-.154.793-.221,1.194-.1.605-.183,1.216-.273,1.826-.041.279-.086.556-.124.836.036-.259.077-.516.115-.775C532.373,312.244,532.459,311.611,532.563,310.986Zm4.187-15.388a58.727,58.727,0,0,0-1.969,5.644c.28-.946.574-1.879.889-2.788.143-.413.306-.8.457-1.209.205-.551.4-1.113.622-1.647.193-.469.407-.909.61-1.364.171-.381.334-.774.513-1.144-.131.272-.25.563-.376.841C537.243,294.482,536.985,295.024,536.749,295.6Zm1.2-2.691v0h0Zm-4.788,14.832v0Zm58.057,124.65a22.573,22.573,0,0,1-1.99,1.157c.647-.33,1.267-.7,1.879-1.08C591.148,432.442,591.183,432.414,591.221,432.389Zm-70.439-36.1,27.107,13.946-27.108-13.946Z",
    transform: "translate(-445.693 -278.021)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M634.214,323.564a9.568,9.568,0,0,0-2.633-3.462,30.507,30.507,0,0,0-14.339-7.285c-22.763-11.245-69.261-31.389-69.261-31.389a16.011,16.011,0,0,0-1.756,1.062,16.411,16.411,0,0,1,1.756-1.062c-17.254-7.147-22.564-1.43-26.239,2.451s-5.31,13.071-3.676,26.344,7.377,47.2-6.331,60.653c-11.027,10.823-52.684-1.428-52.688-1.429-7.454-4.085-17.358,1.633-10.9,10.823s9.927,6.892,9.92,30.32l-6.579,3.376a9.837,9.837,0,0,0-3.341,3.229c-4.019,6.109-3.345,17.05,3.8,21.124l71.629,38.048a16.759,16.759,0,0,0,15.432.15L589.19,451.1a25.4,25.4,0,0,0,13.045-16.027l28.73-106.14a4.034,4.034,0,0,0,2.73-1.229A4.115,4.115,0,0,0,634.214,323.564Z",
    transform: "translate(-107.102 -81.177)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(338.592 196.845)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M483.11,596.129l0,.009,3.622,2.308c.024.015.046.031.07.045l.008,0v0a4.113,4.113,0,0,0,4.077-.427,12.723,12.723,0,0,0,5.773-10,4.084,4.084,0,0,0-1.625-3.663l0,0-.052-.033c-.015-.009-.029-.02-.045-.029l-1.066-.676,34.674-14.092a2.526,2.526,0,0,0,1.305,2.019l-3.124,27.269v3.7a12.871,12.871,0,0,0-4.777,9.3c.005,1.889.7,3.185,1.8,3.761l0,.009,3.621,2.306c.024.015.047.033.072.047l.008,0v0a4.113,4.113,0,0,0,4.077-.427,12.721,12.721,0,0,0,5.773-10,4.081,4.081,0,0,0-1.624-3.663v0l-.05-.032-.048-.03-3.668-2.328-.006.011a3.091,3.091,0,0,0-1.922-.42l3.994-28.418v0a8.553,8.553,0,0,0,2.531-.4v0l32.842,17.743-1.89,1.2-.05.032-.048.031v0a4.083,4.083,0,0,0-1.625,3.663,12.726,12.726,0,0,0,5.773,10,4.113,4.113,0,0,0,4.077.427h0l.007,0c.025-.014.048-.031.073-.046l3.621-2.308,0-.008c1.1-.576,1.8-1.872,1.8-3.762a12.889,12.889,0,0,0-4.7-9.25v-5.724l-30.574-18.161,16.121-4.064a11.738,11.738,0,0,0-1.716,5.73c.005,1.89.7,3.186,1.8,3.762l0,.008,3.625,2.31c.023.013.044.03.067.043l.009,0h0a4.115,4.115,0,0,0,4.077-.427,12.726,12.726,0,0,0,5.773-10,4.082,4.082,0,0,0-1.626-3.663l0,0-.048-.03-.05-.032-3.668-2.328-.006.01a3.367,3.367,0,0,0-2.731-.265v-.924l-1.966-.664-26.191,1.378v-4.626c.277-.126.566-.24.822-.388,1.72-.993,2.587-2.3,2.6-3.6V518.057H525.126v30.292c-.008,1.3.842,2.606,2.554,3.6a9.409,9.409,0,0,0,.863.409v3.888l-18.933-4.09-.907.363V556c-.011.006-.024.011-.035.018l-.006-.011-3.668,2.328c-.016.009-.033.022-.049.031l-.048.031v0a4.084,4.084,0,0,0-1.624,3.664,12.514,12.514,0,0,0,2.853,7.372l-18.29,8.241V582a6.682,6.682,0,0,0-.756.373,12.718,12.718,0,0,0-5.773,9.993C481.31,594.257,482.007,595.553,483.11,596.129Zm10.9-19.546,13.249-5.9h0l-17.91,7.98Zm23.434-14.895,2.682,1.438-1.852.834A12.7,12.7,0,0,0,517.448,561.687Zm11.1-.489-9.978,4.446h0Z",
    transform: "translate(-453.433 -330.19)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.872 187.867)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.911 38.942)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M592.954,575.6l2.9-4.972-3.766-2.389-.006.01c-1.058-.656-2.538-.6-4.183.35a12.725,12.725,0,0,0-5.773,9.993c.005,1.89.7,3.186,1.8,3.762l0,.008,3.7,2.358,3.056-5.236A13.867,13.867,0,0,0,592.954,575.6Z",
    transform: "translate(-582.129 -567.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M592.716,571.65c3.2-1.846,5.8-.368,5.811,3.305a12.726,12.726,0,0,1-5.773,10c-3.2,1.846-5.8.368-5.811-3.311A12.723,12.723,0,0,1,592.716,571.65Z",
    transform: "translate(-583.175 -568.474)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.966 37.526)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M514.348,573.791l-2.9-4.972,3.766-2.39.006.011c1.058-.656,2.537-.6,4.183.35a12.725,12.725,0,0,1,5.773,9.993c-.005,1.89-.7,3.186-1.8,3.762l0,.008-3.7,2.358-3.056-5.236A13.88,13.88,0,0,1,514.348,573.791Z",
    transform: "translate(-509.822 -566.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M515.181,569.84c-3.2-1.846-5.8-.368-5.81,3.305a12.722,12.722,0,0,0,5.773,10c3.2,1.845,5.8.367,5.81-3.312A12.723,12.723,0,0,0,515.181,569.84Z",
    transform: "translate(-509.371 -566.664)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M541.66,560.225H552.4v18.513h0a2.7,2.7,0,0,1-1.586,2.2,8.371,8.371,0,0,1-7.594,0,2.658,2.658,0,0,1-1.561-2.2h0Z",
    transform: "translate(-494.422 -527.222)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.979 37.526)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M583.541,566.851v4.414l-28.157,7.1v-9.343Z",
    transform: "translate(-555.384 -566.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M583.541,566.667,581.575,566l-26.191,1.378v1.455Z",
    transform: "translate(-555.384 -566.003)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.431 70.412)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M594.159,615.809l-2.9-4.971,3.766-2.39.006.01c1.058-.656,2.537-.6,4.182.351a12.721,12.721,0,0,1,5.774,9.992c-.005,1.89-.7,3.186-1.8,3.762l0,.008-3.7,2.358-3.056-5.235A13.861,13.861,0,0,1,594.159,615.809Z",
    transform: "translate(-589.632 -608.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M594.992,611.858c-3.2-1.845-5.8-.367-5.811,3.305a12.726,12.726,0,0,0,5.773,10c3.2,1.846,5.8.368,5.811-3.311A12.725,12.725,0,0,0,594.992,611.858Z",
    transform: "translate(-589.181 -608.683)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.642 83.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M544.058,631.925l2.9-4.971-3.766-2.39-.006.011c-1.058-.657-2.538-.6-4.183.35a12.722,12.722,0,0,0-5.773,9.993c.005,1.889.7,3.185,1.8,3.761l0,.009,3.7,2.358,3.056-5.236A13.87,13.87,0,0,0,544.058,631.925Z",
    transform: "translate(-533.233 -624.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M543.82,627.975c3.2-1.846,5.8-.368,5.811,3.3a12.721,12.721,0,0,1-5.773,10c-3.2,1.846-5.8.368-5.811-3.311A12.72,12.72,0,0,1,543.82,627.975Z",
    transform: "translate(-534.279 -624.799)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 63.53)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M492.13,607.017l2.9-4.972-3.767-2.39-.005.011c-1.058-.657-2.538-.6-4.183.35a12.719,12.719,0,0,0-5.773,9.993c.005,1.889.7,3.185,1.8,3.762l0,.009,3.7,2.358,3.057-5.236A13.9,13.9,0,0,0,492.13,607.017Z",
    transform: "translate(-481.305 -599.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M491.892,603.066c3.2-1.845,5.8-.368,5.81,3.3a12.722,12.722,0,0,1-5.773,10c-3.2,1.846-5.8.368-5.811-3.311A12.718,12.718,0,0,1,491.892,603.066Z",
    transform: "translate(-482.351 -599.89)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.2 43.815)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M589.534,597.821v7.148l-37.7-20.367v-9.857Z",
    transform: "translate(-551.834 -574.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M591.714,596.441,554,574.039l-2.166.552,37.7,23.077Z",
    transform: "translate(-551.834 -574.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M602.183,609.81,600,611.036v-7.148l2.18-1.226Z",
    transform: "translate(-562.303 -580.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M547.324,574.744l-4.595,36.438V617.7L547.324,585Z",
    transform: "translate(-494.655 -530.377)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 2.656,
    height: 6.515,
    transform: "translate(45.418 80.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M539.336,611.182l4.175-36.438h3.076l-4.595,36.438Z",
    transform: "translate(-493.917 -530.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M491.588,590.639v6.841l39.19-15.927v-8.375Z",
    transform: "translate(-483.54 -530.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M489.647,601.048l1.519,1.008v-6.841l-1.519-.983Z",
    transform: "translate(-483.118 -534.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M495.827,588.045l-4.661,2.077-1.519-.983L530.356,570.8v1.864Z",
    transform: "translate(-483.118 -529.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M516.31,562.089v4.48l11.428,6.126,8.412-3.79v-1.838Z",
    transform: "translate(-488.913 -527.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.31,561.988l.907-.363,18.934,4.09v1.251Z",
    transform: "translate(-488.913 -527.526)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M537.294,518.057H554.87v30.292h0c-.009,1.3-.875,2.6-2.6,3.6a13.7,13.7,0,0,1-12.426,0c-1.712-.995-2.562-2.3-2.554-3.6h0Z",
    transform: "translate(-493.473 -518.057)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M448.15,431.1a11.309,11.309,0,0,0,3.8,3.591l71.629,38.048a16.757,16.757,0,0,0,15.432.15l50.179-25.414a25.408,25.408,0,0,0,13.045-16.028l24.21-89.442c.4.128.808.259,1.216.374a9.85,9.85,0,0,0,3.163.481c.047,0,.093-.015.14-.019l-28.73,106.14a25.405,25.405,0,0,1-13.045,16.028l-50.179,25.415a16.759,16.759,0,0,1-15.432-.15l-71.629-38.047C444.8,448.152,444.131,437.21,448.15,431.1Z",
    transform: "translate(-445.694 -291.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M448.15,431.1a11.309,11.309,0,0,0,3.8,3.591l71.629,38.048a16.757,16.757,0,0,0,15.432.15l50.179-25.414a25.408,25.408,0,0,0,13.045-16.028l24.21-89.442c.4.128.808.259,1.216.374a9.85,9.85,0,0,0,3.163.481c.047,0,.093-.015.14-.019l-28.73,106.14a25.405,25.405,0,0,1-13.045,16.028l-50.179,25.415a16.759,16.759,0,0,1-15.432-.15l-71.629-38.047C444.8,448.152,444.131,437.21,448.15,431.1Z",
    transform: "translate(-445.694 -291.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M452.173,444.323l51.9-26.626,68.35,35.162c-2.227.539-4.484.986-6.722,1.436-5.877,1.181-11.871,2.482-16.975,5.623s-9.233,8.515-9.269,14.509l1.828,14.105h0l-1.594.807a16.757,16.757,0,0,1-15.432-.15l-71.629-38.048a11.308,11.308,0,0,1-3.8-3.591A9.837,9.837,0,0,1,452.173,444.323Z",
    transform: "translate(-446.376 -308.378)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M452.173,444.323l51.9-26.626,68.35,35.162c-2.227.539-4.484.986-6.722,1.436-5.877,1.181-11.871,2.482-16.975,5.623s-9.233,8.515-9.269,14.509l1.828,14.105h0l-1.594.807a16.757,16.757,0,0,1-15.432-.15l-71.629-38.048a11.308,11.308,0,0,1-3.8-3.591A9.837,9.837,0,0,1,452.173,444.323Z",
    transform: "translate(-446.376 -308.378)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M462.755,369.447s41.66,12.253,52.688,1.429c13.708-13.453,7.965-47.379,6.331-60.653s0-22.464,3.676-26.344,8.985-9.6,26.239-2.451c-17.457,8.986-19.7,51.69-14.19,68.833-13.683,14.08-12.744,35.9-13.009,46.024,0,0-35.595,8.7-54.179,18.906Z",
    transform: "translate(-449.402 -278.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M462.755,369.447s41.66,12.253,52.688,1.429c13.708-13.453,7.965-47.379,6.331-60.653s0-22.464,3.676-26.344,8.985-9.6,26.239-2.451c-17.457,8.986-19.7,51.69-14.19,68.833-13.683,14.08-12.744,35.9-13.009,46.024,0,0-35.595,8.7-54.179,18.906Z",
    transform: "translate(-449.402 -278.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M466.7,440.207l-8.533-4.6c.007-23.428-3.459-21.13-9.92-30.32s3.443-14.908,10.9-10.823S469.606,410.838,466.7,440.207Z",
    transform: "translate(-445.795 -303.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M466.7,440.207l-8.533-4.6c.007-23.428-3.459-21.13-9.92-30.32s3.443-14.908,10.9-10.823S469.606,410.838,466.7,440.207Z",
    transform: "translate(-445.795 -303.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M574.525,282.375s46.667,20.218,69.386,31.45l-1.654,8.288-74.432-33.8A19.911,19.911,0,0,1,574.525,282.375Z",
    transform: "translate(-472.237 -278.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M574.525,282.375s46.667,20.218,69.386,31.45l-1.654,8.288-74.432-33.8A19.911,19.911,0,0,1,574.525,282.375Z",
    transform: "translate(-472.237 -278.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M554.642,352.857c-4.707-14.635-3.75-47.883,7.491-62.893l74.432,33.8L619.553,409.03,592.594,425.1l-50.961-26.217C541.9,388.757,540.959,366.938,554.642,352.857Z",
    transform: "translate(-466.544 -280.617)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.314 68.718)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.555 20.306)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M616.476,392.08c-1.262-.729-2.291-.145-2.295,1.3a5.023,5.023,0,0,0,2.279,3.949c1.262.729,2.29.145,2.295-1.308A5.025,5.025,0,0,0,616.476,392.08Z",
    transform: "translate(-614.181 -391.766)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.037 13.538)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M601.759,383.432c-1.262-.729-2.291-.146-2.295,1.3a5.023,5.023,0,0,0,2.279,3.949c1.263.729,2.291.145,2.295-1.308A5.023,5.023,0,0,0,601.759,383.432Z",
    transform: "translate(-599.464 -383.118)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.518 6.769)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M587.041,374.783c-1.262-.729-2.29-.145-2.294,1.3a5.021,5.021,0,0,0,2.279,3.949c1.262.729,2.291.146,2.295-1.307A5.023,5.023,0,0,0,587.041,374.783Z",
    transform: "translate(-584.747 -374.469)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M572.325,366.135c-1.262-.729-2.291-.146-2.295,1.3a5.023,5.023,0,0,0,2.279,3.949c1.262.729,2.291.145,2.295-1.308A5.025,5.025,0,0,0,572.325,366.135Z",
    transform: "translate(-570.03 -365.821)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.869 89.024)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M616.476,392.08c-1.262-.729-2.291-.145-2.295,1.3a5.023,5.023,0,0,0,2.279,3.949c1.262.729,2.29.145,2.295-1.308A5.025,5.025,0,0,0,616.476,392.08Z",
    transform: "translate(-614.181 -391.766)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.351 82.255)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M601.759,383.432c-1.262-.729-2.291-.146-2.295,1.3a5.023,5.023,0,0,0,2.279,3.949c1.263.729,2.291.145,2.295-1.308A5.023,5.023,0,0,0,601.759,383.432Z",
    transform: "translate(-599.464 -383.118)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.832 75.486)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M587.041,374.783c-1.262-.729-2.29-.145-2.294,1.3a5.021,5.021,0,0,0,2.279,3.949c1.262.729,2.291.146,2.295-1.307A5.023,5.023,0,0,0,587.041,374.783Z",
    transform: "translate(-584.747 -374.469)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.314 68.718)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M572.325,366.135c-1.262-.729-2.291-.146-2.295,1.3a5.023,5.023,0,0,0,2.279,3.949c1.262.729,2.291.145,2.295-1.308A5.025,5.025,0,0,0,572.325,366.135Z",
    transform: "translate(-570.03 -365.821)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M573.893,441.284c5.1-3.142,11.1-4.442,16.975-5.623,2.238-.45,4.495-.9,6.722-1.436a41.533,41.533,0,0,0,10.4-3.793c8.234-4.547,13.759-13.047,16.409-22.072s2.71-18.6,2.149-27.991S624.83,361.6,625.114,352.2c.166-5.468,1-11.323,4.7-15.353,3.809-4.15,9.975-5.442,15.557-4.689a31.336,31.336,0,0,1,5.4,1.269l2.472,2.889-.949,3.5-24.21,89.442a25.387,25.387,0,0,1-11.125,14.925c-.625.388-1.258.768-1.92,1.1L566.452,469.9l-1.828-14.105C564.66,449.8,568.789,444.426,573.893,441.284Z",
    transform: "translate(-471.541 -289.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M573.893,441.284c5.1-3.142,11.1-4.442,16.975-5.623,2.238-.45,4.495-.9,6.722-1.436a41.533,41.533,0,0,0,10.4-3.793c8.234-4.547,13.759-13.047,16.409-22.072s2.71-18.6,2.149-27.991S624.83,361.6,625.114,352.2c.166-5.468,1-11.323,4.7-15.353,3.809-4.15,9.975-5.442,15.557-4.689a31.336,31.336,0,0,1,5.4,1.269l2.472,2.889-.949,3.5-24.21,89.442a25.387,25.387,0,0,1-11.125,14.925c-.625.388-1.258.768-1.92,1.1L566.452,469.9l-1.828-14.105C564.66,449.8,568.789,444.426,573.893,441.284Z",
    transform: "translate(-471.541 -289.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M576.385,429.416c17.77-5.065,35.231-5.725,41.664-18.49s6.892-30.379,3.675-61.012a46.662,46.662,0,0,1,.283-11.856c1.892-11.461,8.791-16.361,16.719-16.48a30.884,30.884,0,0,1,21.26,7.99,9.568,9.568,0,0,1,2.633,3.462,4.115,4.115,0,0,1-.52,4.142,4.03,4.03,0,0,1-2.73,1.229c-.047,0-.093.016-.14.019a9.85,9.85,0,0,1-3.163-.481c-.409-.115-.812-.247-1.216-.374-2.174-.686-4.309-1.5-6.524-2.042a14.282,14.282,0,0,0-8,0,8.511,8.511,0,0,0-5.137,5.734c-7.492,24.475,2,50.774-6.421,70.991-6.892,18.38-30.718,26.009-47.523,31.46h0a10.249,10.249,0,0,0,4.2-3.053,7.066,7.066,0,0,0-.657-8.516A9.264,9.264,0,0,0,576.385,429.416Z",
    transform: "translate(-474.097 -287.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M576.385,429.416c17.77-5.065,35.231-5.725,41.664-18.49s6.892-30.379,3.675-61.012a46.662,46.662,0,0,1,.283-11.856c1.892-11.461,8.791-16.361,16.719-16.48a30.884,30.884,0,0,1,21.26,7.99,9.568,9.568,0,0,1,2.633,3.462,4.115,4.115,0,0,1-.52,4.142,4.03,4.03,0,0,1-2.73,1.229c-.047,0-.093.016-.14.019a9.85,9.85,0,0,1-3.163-.481c-.409-.115-.812-.247-1.216-.374-2.174-.686-4.309-1.5-6.524-2.042a14.282,14.282,0,0,0-8,0,8.511,8.511,0,0,0-5.137,5.734c-7.492,24.475,2,50.774-6.421,70.991-6.892,18.38-30.718,26.009-47.523,31.46h0a10.249,10.249,0,0,0,4.2-3.053,7.066,7.066,0,0,0-.657-8.516A9.264,9.264,0,0,0,576.385,429.416Z",
    transform: "translate(-474.097 -287.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M559.676,471.9a26.311,26.311,0,0,1,4.548-7.967,13.627,13.627,0,0,1,7.781-4.61,9.264,9.264,0,0,1,8.4,2.726,7.066,7.066,0,0,1,.657,8.516,10.249,10.249,0,0,1-4.2,3.053,39.506,39.506,0,0,0-3.907,1.926c-3.376,2.072-5.57,5.694-6.715,9.487a49.114,49.114,0,0,0-1.553,11.752l-.063.765-8.32-4.617A50.974,50.974,0,0,1,559.676,471.9Z",
    transform: "translate(-469.718 -317.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M559.676,471.9a26.311,26.311,0,0,1,4.548-7.967,13.627,13.627,0,0,1,7.781-4.61,9.264,9.264,0,0,1,8.4,2.726,7.066,7.066,0,0,1,.657,8.516,10.249,10.249,0,0,1-4.2,3.053,39.506,39.506,0,0,0-3.907,1.926c-3.376,2.072-5.57,5.694-6.715,9.487a49.114,49.114,0,0,0-1.553,11.752l-.063.765-8.32-4.617A50.974,50.974,0,0,1,559.676,471.9Z",
    transform: "translate(-469.718 -317.396)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M643.234,462.3c-.179.359-.381.7-.577,1.053C642.853,463.006,643.055,462.66,643.234,462.3Z",
    transform: "translate(-488.501 -318.072)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M641.63,465.046c-.243.387-.5.759-.766,1.132C641.127,465.806,641.388,465.432,641.63,465.046Z",
    transform: "translate(-488.111 -318.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M571.186,285.817c-.452.417-.895.854-1.322,1.321Q570.505,286.438,571.186,285.817Z",
    transform: "translate(-472.68 -279.716)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M573.273,284.111c-.445.325-.882.664-1.3,1.036C572.392,284.777,572.828,284.435,573.273,284.111Z",
    transform: "translate(-473.138 -279.345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M567.825,289.483c.455-.608.928-1.182,1.417-1.727C568.754,288.3,568.281,288.876,567.825,289.483Z",
    transform: "translate(-472.237 -280.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M558.688,308a86.419,86.419,0,0,0-2.631,12.8A86.411,86.411,0,0,1,558.688,308Z",
    transform: "translate(-469.679 -284.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M567.549,289.964c-.34.453-.668.925-.989,1.411Q567.041,290.646,567.549,289.964Z",
    transform: "translate(-471.962 -280.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M566.222,291.886q-.479.731-.932,1.507Q565.742,292.616,566.222,291.886Z",
    transform: "translate(-471.686 -281.035)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M564,293.838a50.23,50.23,0,0,0-4.574,11.054A50.173,50.173,0,0,1,564,293.838Z",
    transform: "translate(-470.413 -281.459)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M555.945,324.7q-.126.969-.232,1.941Q555.821,325.667,555.945,324.7Z",
    transform: "translate(-469.605 -288.166)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M555.6,327.743q-.1.94-.185,1.882Q555.5,328.683,555.6,327.743Z",
    transform: "translate(-469.54 -288.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M555.326,330.733c-.054.637-.106,1.275-.149,1.911C555.22,332.007,555.272,331.371,555.326,330.733Z",
    transform: "translate(-469.488 -289.478)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M555.1,333.362c-.132,2-.207,3.986-.234,5.945C554.893,337.348,554.969,335.362,555.1,333.362Z",
    transform: "translate(-469.421 -290.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M554.853,341.941c0,.474,0,.943,0,1.414C554.852,342.884,554.849,342.415,554.853,341.941Z",
    transform: "translate(-469.417 -291.913)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M557.626,368.167c-.048-.178-.093-.366-.14-.549C557.533,367.8,557.578,367.988,557.626,368.167Z",
    transform: "translate(-469.99 -297.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M557.084,365.964c-.051-.224-.1-.454-.149-.682C556.984,365.511,557.034,365.741,557.084,365.964Z",
    transform: "translate(-469.87 -296.986)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M556.6,363.63c-.048-.25-.1-.5-.142-.758C556.505,363.128,556.552,363.38,556.6,363.63Z",
    transform: "translate(-469.767 -296.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M556.171,361.159c-.042-.265-.085-.527-.125-.8C556.086,360.632,556.129,360.9,556.171,361.159Z",
    transform: "translate(-469.677 -295.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M555.793,358.513c-.034-.254-.069-.5-.1-.761C555.724,358.009,555.76,358.259,555.793,358.513Z",
    transform: "translate(-469.6 -295.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M555.406,355.072c-.028-.292-.052-.59-.077-.887C555.355,354.482,555.378,354.78,555.406,355.072Z",
    transform: "translate(-469.521 -294.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M555.161,352.076c-.025-.357-.045-.72-.067-1.082C555.116,351.356,555.136,351.719,555.161,352.076Z",
    transform: "translate(-469.47 -293.881)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M555,349.2c-.02-.4-.034-.8-.05-1.2C554.962,348.4,554.978,348.806,555,349.2Z",
    transform: "translate(-469.438 -293.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M554.9,346.289c-.012-.43-.021-.861-.027-1.3C554.874,345.428,554.884,345.859,554.9,346.289Z",
    transform: "translate(-469.421 -292.577)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    height: 44.87,
    transform: "translate(95.038 106.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M564.924,501.549l1.594-.807L615.1,476.134c.662-.335,1.295-.715,1.92-1.1.581-.362,1.137-.755,1.684-1.159a25.321,25.321,0,0,1-3.6,2.262Z",
    transform: "translate(-471.606 -320.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M634.126,473.2c.483-.37.944-.765,1.4-1.168C635.07,472.432,634.609,472.826,634.126,473.2Z",
    transform: "translate(-486.646 -320.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M636.58,471.1c.4-.378.79-.772,1.167-1.175C637.37,470.331,636.983,470.723,636.58,471.1Z",
    transform: "translate(-487.18 -319.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M639.793,467.594c-.308.4-.629.785-.96,1.165Q639.33,468.191,639.793,467.594Z",
    transform: "translate(-487.669 -319.222)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M644.212,460.243c.124-.29.261-.573.374-.869C644.474,459.67,644.336,459.952,644.212,460.243Z",
    transform: "translate(-488.839 -317.436)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.853 149.734)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M505.181,500.281c8.216-3.538,19.4-17.357,25-24.332,7.112-8.856,6.321-28.157,4.709-36.957l-69.94-5.465c-1.994,19.147-19.595,31.691-19.595,31.691Z",
    transform: "translate(-262.881 -264.708)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.743 261.316)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 37.994)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M358.334,600.253c.272,6.461,0,14.051,0,14.051l3.751.207a9.086,9.086,0,0,1,8.043,5.98l.085.236A3.54,3.54,0,0,0,374.6,622.9h0a3.539,3.539,0,0,0,2.139-1.849l1.919-16.208Z",
    transform: "translate(-321.712 -600.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M342.662,666.422c-9.827,4.2-24.875,5.016-31.12-5.016v2.715c6.245,10.032,21.292,9.214,31.12,5.016s7.678-11.056,16.481-14.741a23.859,23.859,0,0,0,8.6-5.425c.034-.8.17-1.8.306-2.962a29.923,29.923,0,0,1-8.905,5.672C350.339,655.366,352.489,662.224,342.662,666.422Z",
    transform: "translate(-311.542 -610.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M368.049,631.051a14.145,14.145,0,0,1,.05-5.8,3.093,3.093,0,0,0-.447-2.569l-.733-.722-.354,2.988a3.54,3.54,0,0,1-6.521-.325l-.085-.236a9.086,9.086,0,0,0-8.043-5.98l-3.812-.21a2.742,2.742,0,0,0-2.688,1.688c-3.922,9.458-13.784,19.966-21.385,24.777-5.579-.128-12.489,4.5-12.489,10.135v.56c6.245,10.032,21.292,9.214,31.12,5.016s7.678-11.056,16.481-14.741a29.923,29.923,0,0,0,8.905-5.672A32.075,32.075,0,0,0,368.049,631.051Z",
    transform: "translate(-311.542 -604.153)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.913)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M355.96,642.517a1.247,1.247,0,0,0,1.943-1.562,14.242,14.242,0,0,0-12.834-5.638q-.788.974-1.608,1.921C348.091,636.985,352.236,637.98,355.96,642.517Z",
    transform: "translate(-318.479 -630.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M360.8,636.934a1.247,1.247,0,0,0,1.943-1.562,14.967,14.967,0,0,0-13.392-5.781c-.47.7-.967,1.4-1.475,2.094C352.674,631.349,356.96,632.258,360.8,636.934Z",
    transform: "translate(-319.438 -629.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M350.822,647.937a1.247,1.247,0,0,0,1.943-1.563,14.225,14.225,0,0,0-12.5-5.662c-.634.668-1.276,1.314-1.921,1.944C342.967,642.409,347.1,643.407,350.822,647.937Z",
    transform: "translate(-317.368 -631.952)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M324.031,652.015c-5.579-.128-12.489,4.5-12.489,10.135v.56c6.153,9.884,20.839,9.228,30.67,5.192C341.455,654.4,328.491,651.965,324.031,652.015Z",
    transform: "translate(-311.542 -634.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M345.4,653.11a1.247,1.247,0,0,0,1.943-1.562,14.228,14.228,0,0,0-12.527-5.66c-.784.7-1.565,1.353-2.339,1.973C337.278,647.525,341.564,648.436,345.4,653.11Z",
    transform: "translate(-316.092 -633.076)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.862 50.44)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M442.484,616.155c.272,6.461,0,14.052,0,14.052l3.752.207a9.085,9.085,0,0,1,8.043,5.98l.085.236a3.541,3.541,0,0,0,4.383,2.175h0a3.542,3.542,0,0,0,2.139-1.849l1.919-16.207Z",
    transform: "translate(-405.862 -616.155)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M426.813,682.324c-9.828,4.2-24.875,5.016-31.12-5.016v2.715c6.244,10.032,21.292,9.214,31.12,5.016s7.677-11.055,16.481-14.741a23.847,23.847,0,0,0,8.6-5.425c.034-.8.171-1.8.307-2.962a29.9,29.9,0,0,1-8.906,5.672C434.49,671.269,436.64,678.127,426.813,682.324Z",
    transform: "translate(-395.693 -626.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M452.2,646.953a14.13,14.13,0,0,1,.049-5.8,3.09,3.09,0,0,0-.447-2.569l-.732-.722-.354,2.988a3.541,3.541,0,0,1-6.522-.326l-.085-.236a9.084,9.084,0,0,0-8.043-5.98l-3.813-.211a2.74,2.74,0,0,0-2.687,1.689c-3.923,9.458-13.784,19.966-21.386,24.777-5.579-.128-12.488,4.5-12.488,10.134v.56c6.244,10.032,21.292,9.214,31.12,5.016s7.677-11.055,16.481-14.741a29.905,29.905,0,0,0,8.906-5.672A32.1,32.1,0,0,0,452.2,646.953Z",
    transform: "translate(-395.693 -620.055)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.913)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M440.111,658.42a1.247,1.247,0,0,0,1.943-1.563,14.242,14.242,0,0,0-12.834-5.637q-.788.973-1.608,1.92C432.241,652.888,436.387,653.882,440.111,658.42Z",
    transform: "translate(-402.63 -646.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M444.947,652.837a1.247,1.247,0,0,0,1.943-1.563,14.966,14.966,0,0,0-13.393-5.78c-.47.7-.966,1.4-1.475,2.093C436.824,647.251,441.11,648.161,444.947,652.837Z",
    transform: "translate(-403.589 -645.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M434.973,663.839a1.247,1.247,0,0,0,1.943-1.562,14.223,14.223,0,0,0-12.5-5.662c-.634.668-1.276,1.313-1.921,1.944C427.117,658.311,431.255,659.31,434.973,663.839Z",
    transform: "translate(-401.518 -647.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M408.181,667.918c-5.579-.128-12.488,4.5-12.488,10.134v.56c6.152,9.884,20.839,9.228,30.67,5.193C425.6,670.3,412.642,667.867,408.181,667.918Z",
    transform: "translate(-395.693 -650.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M429.55,669.013a1.247,1.247,0,0,0,1.943-1.562,14.227,14.227,0,0,0-12.527-5.66c-.784.7-1.565,1.352-2.339,1.972C421.428,663.427,425.714,664.339,429.55,669.013Z",
    transform: "translate(-400.243 -648.979)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M394.482,564.8c-3.16,13.326-5.294,21.71-11.087,39.621,0,0-22.416,4.8-31.256-3.949l10.089-48.766Z",
    transform: "translate(-320.365 -551.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M466.617,573.326c-.858,13.668-.359,25.991-3.036,44.624,0,0-19.1,6.341-29.3-.787l-1.671-32.577Z",
    transform: "translate(-337.855 -556.407)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 123.056)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.007 43.08)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M538.554,522.162l-4.191-2.425v29.55l-93.91,54.3V578.817l-4.191,2.425-4.191-2.425V697.352l4.191,2.425,4.191-2.425v-84.5l93.91-54.219v79.641l4.191,2.425,4.192-2.425V519.737Z",
    transform: "translate(-260.001 -449.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M220.6,484.4V459.628l-4.191,2.425-4.191-2.425V578.163l4.191,2.425,4.191-2.425v-84.5l98.1-56.639v-4.5l-4.191-2.42Z",
    transform: "translate(-212.22 -430.098)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.007 43.08)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M217.575,470.252V588.787l4.191-2.425V467.827Z",
    transform: "translate(-213.384 -438.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M216.411,470.252V588.787l-4.191-2.425V467.827Z",
    transform: "translate(-212.22 -438.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M222.93,494.333l98.1-56.639v-4.5l-98.1,56.639Z",
    transform: "translate(-214.548 -430.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M222.93,484.4l93.91-54.3,4.191,2.42-98.1,56.639Z",
    transform: "translate(-214.548 -430.098)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.069 70.157)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M568.123,522.162V640.7l4.192-2.425V519.737Z",
    transform: "translate(-461.639 -519.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M566.959,522.162V640.7l-4.191-2.425V519.737Z",
    transform: "translate(-460.475 -519.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M437.425,597.647V716.182l4.191-2.425V595.222Z",
    transform: "translate(-433.234 -536.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M436.262,597.647V716.182l-4.191-2.425V595.222Z",
    transform: "translate(-432.07 -536.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M442.781,621.728l98.1-56.639v-4.5l-98.1,56.639Z",
    transform: "translate(-434.398 -528.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M442.781,611.8l93.91-54.3,4.191,2.42-98.1,56.639Z",
    transform: "translate(-434.398 -527.943)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(172.069 70.157)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M568.123,522.162V640.7l4.192-2.425V519.737Z",
    transform: "translate(-461.639 -519.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M566.959,522.162V640.7l-4.191-2.425V519.737Z",
    transform: "translate(-460.475 -519.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M437.425,597.647V716.182l4.191-2.425V595.222Z",
    transform: "translate(-433.234 -536.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M436.262,597.647V716.182l-4.191-2.425V595.222Z",
    transform: "translate(-432.07 -536.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M442.781,621.728l98.1-56.639v-4.5l-98.1,56.639Z",
    transform: "translate(-434.398 -528.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M442.781,611.8l93.91-54.3,4.191,2.42-98.1,56.639Z",
    transform: "translate(-434.398 -527.943)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M217.575,470.252V588.787l4.191-2.425V467.827Z",
    transform: "translate(-213.384 -438.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M216.411,470.252V588.787l-4.191-2.425V467.827Z",
    transform: "translate(-212.22 -438.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M222.93,494.333l98.1-56.639v-4.5l-98.1,56.639Z",
    transform: "translate(-214.548 -430.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M222.93,484.4l93.91-54.3,4.191,2.42-98.1,56.639Z",
    transform: "translate(-214.548 -430.098)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M494.951,476.84,318.7,375.055,212.211,436.561v11.106L388.479,549.8l106.484-61.505V476.834Z",
    transform: "translate(-212.211 -375.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M388.479,538.352,212.211,436.561,318.7,375.055,494.963,476.847Z",
    transform: "translate(-212.211 -375.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M388.479,566.877,212.211,464.745V453.64L388.479,555.431Z",
    transform: "translate(-212.211 -392.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M437.425,566.6,543.91,505.1v11.459L437.425,578.06Z",
    transform: "translate(-261.158 -403.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M388.479,538.352,212.211,436.561,318.7,375.055,494.963,476.847Z",
    transform: "translate(-212.211 -375.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M437.425,566.6,543.91,505.1v11.459L437.425,578.06Z",
    transform: "translate(-261.158 -403.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M388.479,566.877,212.211,464.745V453.64L388.479,555.431Z",
    transform: "translate(-212.211 -392.134)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.787 167.148)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M321.108,457.71l43.446-25.248a9.821,9.821,0,0,1,8.916,0l71.679,41.384a3.23,3.23,0,0,1,1.842,2.451l.02,0v2.757l-.04,0a2.184,2.184,0,0,1-.055.573c-.005.019-.006.038-.013.057a2.623,2.623,0,0,1-.305.609c-.015.022-.021.044-.036.066a3.5,3.5,0,0,1-.538.6c-.012.012-.02.024-.032.035a4.976,4.976,0,0,1-.8.571l-43.446,25.248a7.066,7.066,0,0,1-1.246.549c-.156.054-.317.1-.478.146-.208.059-.416.114-.632.157-.254.052-.511.1-.772.132-.062.008-.122.02-.185.026-.351.038-.707.056-1.064.059-.056,0-.113,0-.17,0-.351,0-.7-.023-1.049-.059-.053-.005-.1-.011-.157-.018a9.971,9.971,0,0,1-1.014-.174c-.062-.014-.121-.03-.182-.045a8.464,8.464,0,0,1-.874-.266c-.052-.019-.106-.033-.157-.053a6.968,6.968,0,0,1-.962-.453l-71.679-41.384a5.126,5.126,0,0,1-.813-.574c-.081-.071-.131-.149-.2-.223a3.615,3.615,0,0,1-.377-.415,2.539,2.539,0,0,1-.14-.271,2.682,2.682,0,0,1-.209-.408,2.138,2.138,0,0,1-.05-.3,2.176,2.176,0,0,1-.066-.4v-2.541A3.141,3.141,0,0,1,321.108,457.71Z",
    transform: "translate(-319.265 -431.392)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M446.991,484.322a2.156,2.156,0,0,1-.075.785c-.005.02-.006.038-.013.057a2.628,2.628,0,0,1-.305.61c-.015.021-.021.044-.036.065a3.533,3.533,0,0,1-.538.6c-.012.011-.02.023-.032.034a5.029,5.029,0,0,1-.8.571l-43.446,25.248a7.123,7.123,0,0,1-1.246.548c-.156.054-.317.1-.478.146-.208.058-.416.113-.632.157-.254.052-.511.1-.772.132-.062.008-.122.019-.184.026-.352.038-.707.056-1.064.059h-.17c-.351,0-.7-.022-1.049-.059l-.157-.017a10.205,10.205,0,0,1-1.014-.175c-.062-.014-.121-.03-.182-.045a8.856,8.856,0,0,1-.874-.266c-.052-.019-.106-.034-.157-.053a6.961,6.961,0,0,1-.962-.454l-71.679-41.383a5.125,5.125,0,0,1-.813-.575c-.081-.071-.131-.149-.2-.222a3.751,3.751,0,0,1-.377-.415,2.616,2.616,0,0,1-.14-.271,2.717,2.717,0,0,1-.209-.408,2.156,2.156,0,0,1-.05-.3,2.186,2.186,0,0,1-.066-.4v2.541a2.176,2.176,0,0,0,.066.4,2.139,2.139,0,0,0,.05.3,2.682,2.682,0,0,0,.209.408,2.541,2.541,0,0,0,.14.271,3.684,3.684,0,0,0,.377.415c.072.074.122.152.2.223a5.13,5.13,0,0,0,.813.574L392.8,514.833a6.972,6.972,0,0,0,.962.453c.051.02.1.034.157.053a8.449,8.449,0,0,0,.874.266c.061.016.121.031.182.045a9.945,9.945,0,0,0,1.014.174c.052.007.1.013.157.018.347.036.7.056,1.049.059.057,0,.114,0,.17,0,.357,0,.712-.021,1.064-.059.062-.006.122-.018.184-.026.261-.032.518-.08.772-.132.216-.044.424-.1.632-.157.161-.045.322-.092.478-.146a7.066,7.066,0,0,0,1.246-.549l43.446-25.248a4.976,4.976,0,0,0,.8-.571c.013-.011.02-.023.032-.035a3.5,3.5,0,0,0,.538-.6c.015-.022.021-.044.036-.066a2.623,2.623,0,0,0,.305-.609c.006-.019.007-.038.013-.057a2.184,2.184,0,0,0,.055-.573l.04,0v-2.757Z",
    transform: "translate(-319.265 -439.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M327.04,464.333l69.636,40.2a2.293,2.293,0,0,0,.274.132l.151.051a4.41,4.41,0,0,0,.545.16c.187.045.376.074.383.081l.264.025c.185.02.387.03.679.034h.061a6.173,6.173,0,0,0,.713-.047c.149-.019.294-.047.455-.081.109-.021.563-.151.563-.151a2.58,2.58,0,0,0,.483-.2l22.4-13.024-71.931-41.529Z",
    transform: "translate(-320.955 -435.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M419.016,520.3l-.078,0h-.026Z",
    transform: "translate(-340.922 -450.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M407.864,454.1l-13.1,7.705a1.325,1.325,0,0,0,.009,2.29l19.589,11.31a2.176,2.176,0,0,0,2.193-.009l13.1-7.7a1.325,1.325,0,0,0-.009-2.29l-19.588-11.31A2.178,2.178,0,0,0,407.864,454.1Z",
    transform: "translate(-335.531 -436.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M327.04,464.333l69.636,40.2a2.293,2.293,0,0,0,.274.132l.151.051a4.41,4.41,0,0,0,.545.16c.187.045.376.074.383.081l.264.025c.185.02.387.03.679.034h.061a6.173,6.173,0,0,0,.713-.047c.149-.019.294-.047.455-.081.109-.021.563-.151.563-.151a2.58,2.58,0,0,0,.483-.2l22.4-13.024-71.931-41.529Z",
    transform: "translate(-320.955 -435.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M407.864,454.1l-13.1,7.705a1.325,1.325,0,0,0,.009,2.29l19.589,11.31a2.176,2.176,0,0,0,2.193-.009l13.1-7.7a1.325,1.325,0,0,0-.009-2.29l-19.588-11.31A2.178,2.178,0,0,0,407.864,454.1Z",
    transform: "translate(-335.531 -436.262)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.355 73.538)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M400.009,421.053c-5.267,7.616,7.232,18.56,12.581,15.916S411.018,415.406,400.009,421.053Z",
    transform: "translate(-361.106 -335.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M400.009,421.053c-5.267,7.616,7.232,18.56,12.581,15.916S411.018,415.406,400.009,421.053Z",
    transform: "translate(-361.106 -335.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M434.561,334.773l-14.389,43.1L387.955,403.08a13.874,13.874,0,0,1-6.423,1l-12.916-1.061a7.221,7.221,0,0,0-4.334,1.021l-7.4,4.48a8,8,0,0,0-1.969,1.683l-3.62,4.29a2.716,2.716,0,0,0,.5,3.96l2.277,1.63a8.1,8.1,0,0,0,8.361.646l5.72-2.884,11.818,1.3v3.085l-3.2,2.742a3.408,3.408,0,0,0,.078,5.241h0s7.9-2.342,15.062-13.807l37.789-18.679a26.827,26.827,0,0,0,13.627-15.763l21.464-66.1-8.449,1.061A26.424,26.424,0,0,0,434.561,334.773Z",
    transform: "translate(-350.655 -312.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M469.623,313.374a29.258,29.258,0,0,0-23.985,19.664l-14.133,42.335-18.168,14.214A14.078,14.078,0,0,1,424.1,409.33L444.5,399.242A29.678,29.678,0,0,0,459.5,381.9l22.767-70.115Z",
    transform: "translate(-364.278 -311.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M420.832,418.407a14.433,14.433,0,0,0-10.314-7.216l-10.157,7.946a12.659,12.659,0,0,1,12.581,15.916l8.334-4.12A14.437,14.437,0,0,0,420.832,418.407Z",
    transform: "translate(-361.458 -333.392)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M469.623,313.374a29.258,29.258,0,0,0-23.985,19.664l-14.133,42.335-18.168,14.214A14.078,14.078,0,0,1,424.1,409.33L444.5,399.242A29.678,29.678,0,0,0,459.5,381.9l22.767-70.115Z",
    transform: "translate(-364.278 -311.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M420.832,418.407a14.433,14.433,0,0,0-10.314-7.216l-10.157,7.946a12.659,12.659,0,0,1,12.581,15.916l8.334-4.12A14.437,14.437,0,0,0,420.832,418.407Z",
    transform: "translate(-361.458 -333.392)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M436.551,392.049c9.112.192,13.471,4.887,14.561,7.234.419-13.581-13.485-10.458-13.485-10.458Z",
    transform: "translate(-369.323 -328.463)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.818 141.831)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M306.358,400.069l-.019-.007,1.716-.856,0,.012a2.125,2.125,0,0,1,1.918.121L382.15,441.3a8.707,8.707,0,0,1,4.227,6.178l7.42,47.185a2.146,2.146,0,0,1-1.212,2.282l.031.005-1.662.819v-.009a2.128,2.128,0,0,1-1.857-.15l-72.175-41.964a8.71,8.71,0,0,1-4.227-6.178l-7.42-47.185A2.142,2.142,0,0,1,306.358,400.069Z",
    transform: "translate(-305.25 -399.044)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.954 43.274)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M355.426,455.263c3.5,2.019,6.693,6.636,7.162,10.317s-1.961,5.049-5.458,3.03c-3.481-2.01-6.693-6.636-7.162-10.317S351.946,453.254,355.426,455.263Z",
    transform: "translate(-349.91 -454.334)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M392.648,495.391l-7.42-47.185A8.71,8.71,0,0,0,381,442.027l-72.175-41.963a2.131,2.131,0,0,0-2.165,0l-.019-.007,1.716-.856,0,.012a2.125,2.125,0,0,1,1.917.121L382.453,441.3a8.707,8.707,0,0,1,4.227,6.178l7.42,47.185a2.146,2.146,0,0,1-1.212,2.282l.031.005-1.662.819v-.009A2.161,2.161,0,0,0,392.648,495.391Z",
    transform: "translate(-305.552 -399.044)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.052)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 74.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M489.1,313.036l-6.322.668a15.5,15.5,0,0,0-11.36,6.866c-6.572,10.032-9.636,25.461-7.878,42.166,1.338,12.707,2.291,25.326-5.13,44.2-2.645,6.728,1.433,14.349,8.15,17.024,21.26,8.468,51.618,4.694,67.341-.453a9.5,9.5,0,0,0,5.765-12.832s-5.893-32.51-4.759-35.143c2.593-6.025,3.214-20.608,3.837-29.794a48.048,48.048,0,0,0-5.014-23.651l-24.087-9.046Z",
    transform: "translate(-457.593 -313.036)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.497)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M501.581,280.856a11.67,11.67,0,0,0,4.917,3.932,6.668,6.668,0,0,0,5.973-.466,6.578,6.578,0,0,0,2.658-6.07,9.522,9.522,0,0,0,6.55-5.932,10.8,10.8,0,0,0-.838-9.206c3.705-2.153,7.267-5.172,8.729-9.444s-.293-9.732-4.2-11.411a8.326,8.326,0,0,0,1.482-9.574c-1.626-3.034-5.274-4.752-8.327-3.581a11.441,11.441,0,0,0-6.617-9.142,10.474,10.474,0,0,0-10.884,1.656,5.986,5.986,0,0,0-4.549-3.108,5.789,5.789,0,0,0-4.991,2.167,8.339,8.339,0,0,0-9.3-2.317c-3.2,1.16-5.843,4.115-7.575,7.253a6.415,6.415,0,0,0-6.5.347A7.607,7.607,0,0,0,464.9,232.1a7.817,7.817,0,0,0,3.094,6.3,5.528,5.528,0,0,0-3.308,4.276,5.875,5.875,0,0,0,1.838,5.213,4.866,4.866,0,0,0,5.1.8c5.537,5.974,15.257,5.927,21.373,11.2a21.46,21.46,0,0,1,5.843,9.2C500.079,272.605,499.359,277.96,501.581,280.856Z",
    transform: "translate(-464.617 -217.829)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.808 58.557)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M517.877,292.646v16.435a7.748,7.748,0,0,1-2.616,5.832,21.988,21.988,0,0,1-15.709,5.341,5.54,5.54,0,0,1-3.26-1.006,4.3,4.3,0,0,1-1.048-4.471,8.632,8.632,0,0,1,1.194-2.412,7.445,7.445,0,0,0,1.3-4.165V292.646Z",
    transform: "translate(-495.036 -292.646)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M506.656,305.925a44.493,44.493,0,0,1-8.169,1.615V292.646h20.14v3.5a16.123,16.123,0,0,1-1.648,2.886A20.022,20.022,0,0,1,506.656,305.925Z",
    transform: "translate(-495.786 -292.646)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.735 28.699)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M524.061,265.436a6.508,6.508,0,0,0-5.175,1.513,19.37,19.37,0,0,0-3.608,4.211,6.394,6.394,0,0,1-1.8,1.923,2.186,2.186,0,0,1-2.482-.029,3.256,3.256,0,0,1-.706-2.7l.314-6.858a2.734,2.734,0,0,0-1.521-2.553,6.726,6.726,0,0,1-3.073-3.535c-.092-.229-.164-.464-.239-.7a5.735,5.735,0,0,1-4.15.633A5.831,5.831,0,0,1,498,254.782a4.182,4.182,0,0,1-3.171,2.074,4.05,4.05,0,0,1-3.387-1.547,7.212,7.212,0,0,1-11.851-.115,7.51,7.51,0,0,1-7.068-.7,84.516,84.516,0,0,0,2.251,31.555,25.821,25.821,0,0,0,2.6,6.731,10.893,10.893,0,0,0,5.312,4.719c2.781,1.04,5.871.538,8.795.023,5.346-.942,10.832-1.936,15.476-4.746s8.327-7.891,7.878-13.3a9.293,9.293,0,0,0,8.879.491,9.429,9.429,0,0,0,4.869-7.528C528.789,269.411,527.037,266.035,524.061,265.436Z",
    transform: "translate(-471.944 -254.497)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.217 5.896)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M490.413,274.193l-6.168,10.383,7.354,1.381Z",
    transform: "translate(-475.834 -264.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M501.145,293.8l-5.588,2.717a3.655,3.655,0,0,0,4.237,1.2C501.169,297.1,501.554,295.247,501.145,293.8Z",
    transform: "translate(-478.293 -268.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M501.145,293.8l-5.588,2.717a3.655,3.655,0,0,0,4.237,1.2C501.169,297.1,501.554,295.247,501.145,293.8Z",
    transform: "translate(-478.293 -268.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M498.492,298.171a3.369,3.369,0,0,0,1.94-.183,2.974,2.974,0,0,0,1.495-2.945,3.388,3.388,0,0,0-3.435,3.128Z",
    transform: "translate(-478.931 -269.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M504.563,274.193a2.112,2.112,0,1,1-2.314-1.89A2.112,2.112,0,0,1,504.563,274.193Z",
    transform: "translate(-479.334 -264.261)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M481.932,275.6a2.112,2.112,0,1,1-2.314-1.889A2.113,2.113,0,0,1,481.932,275.6Z",
    transform: "translate(-474.416 -264.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M478.127,265.592l-4.334,3.691a3.01,3.01,0,0,1,.578-3.389A3.568,3.568,0,0,1,478.127,265.592Z",
    transform: "translate(-473.499 -262.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M502.372,262.836l4.983,2.752a3.011,3.011,0,0,0-1.242-3.206A3.568,3.568,0,0,0,502.372,262.836Z",
    transform: "translate(-479.774 -262.031)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.54 74.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M557.766,424.978c-7.047,6.911-27.106,15.995-40.742,11.076-3.17-41.322-.266-106.594,5.25-123.018l24.175,8.98c14.335,24.464,4.824,64.521,4.824,64.521A142.069,142.069,0,0,0,557.766,424.978Z",
    transform: "translate(-515.713 -313.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M557.766,424.978c-7.047,6.911-27.106,15.995-40.742,11.076-3.17-41.322-.266-106.594,5.25-123.018l24.175,8.98c14.335,24.464,4.824,64.521,4.824,64.521A142.069,142.069,0,0,0,557.766,424.978Z",
    transform: "translate(-515.713 -313.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M531.857,349.936l-8.606-9.995,6.936-4.82a4.025,4.025,0,0,0,1.242-5.22L522.3,313.036c-3.542,10.546-6,41.232-6.475,72.785l16.545-31.383A4.022,4.022,0,0,0,531.857,349.936Z",
    transform: "translate(-515.737 -313.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M531.857,349.936l-8.606-9.995,6.936-4.82a4.025,4.025,0,0,0,1.242-5.22L522.3,313.036c-3.542,10.546-6,41.232-6.475,72.785l16.545-31.383A4.022,4.022,0,0,0,531.857,349.936Z",
    transform: "translate(-515.737 -313.036)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.478 73.825)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M488.052,312.844c-4.1,5.053-17.748,21.136-19.557,80.384-.469,15.432-7.8,34.006-7.8,34.006l-10.226-14.62S462.1,398.3,462.1,374.641s-4.359-31.981,2.682-46.989,15-14.461,17.356-14.756l5.912-.742Z",
    transform: "translate(-450.472 -312.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M488.052,312.844c-4.1,5.053-17.748,21.136-19.557,80.384-.469,15.432-7.8,34.006-7.8,34.006l-10.226-14.62S462.1,398.3,462.1,374.641s-4.359-31.981,2.682-46.989,15-14.461,17.356-14.756l5.912-.742Z",
    transform: "translate(-450.472 -312.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M491.616,312.154,474.15,326.725a4.024,4.024,0,0,0-1.019,4.893l1.954,3.9-6.41,6.869a6.705,6.705,0,0,0-1.694,5.779l5.747,31.5c3.3-48.195,15.122-62.178,18.887-66.821Z",
    transform: "translate(-454.036 -312.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M491.616,312.154,474.15,326.725a4.024,4.024,0,0,0-1.019,4.893l1.954,3.9-6.41,6.869a6.705,6.705,0,0,0-1.694,5.779l5.747,31.5c3.3-48.195,15.122-62.178,18.887-66.821Z",
    transform: "translate(-454.036 -312.154)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.735 83.495)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M524.287,324.51l-25.4,76.347L453.594,418.45a15.754,15.754,0,0,1-7.291,1.135l-12.17-2.124a8.2,8.2,0,0,0-4.919,1.158l-8.4,5.086a9.075,9.075,0,0,0-2.235,1.91l-4.109,4.87a3.084,3.084,0,0,0,.563,4.5l2.584,1.849a9.194,9.194,0,0,0,9.49.733l6.493-3.274,3,.715a30.367,30.367,0,0,0,19.515-1.857h0l49.132-9.931A21.831,21.831,0,0,0,521.2,409.473s23.481-55.719,17.932-68.322C536.726,335.7,524.287,324.51,524.287,324.51Z",
    transform: "translate(-413.747 -324.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M535.109,324.51l-26.276,75.47-45.294,17.328c8.445,4.716,8.883,15.275,8.006,16.521l47.945-10.038a18.648,18.648,0,0,0,13.628-11.672l19.246-51.032c8.329-22.885-3.765-31.29-17.253-36.578Z",
    transform: "translate(-424.568 -324.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M535.109,324.51l-26.276,75.47-45.294,17.328c8.445,4.716,8.883,15.275,8.006,16.521l47.945-10.038a18.648,18.648,0,0,0,13.628-11.672l19.246-51.032c8.329-22.885-3.765-31.29-17.253-36.578Z",
    transform: "translate(-424.568 -324.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M482.156,445.547a18.07,18.07,0,0,0-6.314-8.484l-12.3,4.707c8.445,4.716,8.883,15.275,8.006,16.521l11.011-2.306A18.055,18.055,0,0,0,482.156,445.547Z",
    transform: "translate(-424.568 -348.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M521.41,419.808c8.335.11,14.148,3.729,15.025,6.362-1.426-12.5-13.663-10.274-13.663-10.274Z",
    transform: "translate(-437.146 -344.338)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.957 13.586)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M63.011,557.367a5.925,5.925,0,0,1-.993.458A5.772,5.772,0,0,0,63.011,557.367Z",
    transform: "translate(-48.673 -155.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M61.066,558.16c-.068.012-.141.038-.208.046C60.925,558.2,61,558.172,61.066,558.16Z",
    transform: "translate(-48.421 -155.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M58.847,557.916V557.9h0c-.02-.01-.045-.013-.065-.024Z",
    transform: "translate(-47.969 -155.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M53.64,303.022l-.047-16.533-8.625-4.91.046,16.152h0v.367l8.625,4.924Z",
    transform: "translate(-44.967 -95.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M54.2,499.1l-.543-191.487-8.625-4.924L45.57,493.8a3.593,3.593,0,0,0,1.448,3.237l-.005,0,.045.027.035.021,8.5,5.2A3.615,3.615,0,0,1,54.2,499.1Z",
    transform: "translate(-44.98 -100.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M54.2,499.1l-.543-191.487-8.625-4.924L45.57,493.8a3.593,3.593,0,0,0,1.448,3.237l-.005,0,.045.027.035.021,8.5,5.2A3.615,3.615,0,0,1,54.2,499.1Z",
    transform: "translate(-44.98 -100.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M53.625,234.8l-.027-9.526a11.218,11.218,0,0,1,5.089-8.825L347.225,49.858a3.624,3.624,0,0,1,3.571-.377l-8.513-5.228v.009a3.54,3.54,0,0,0-3.684.305L50.061,211.154a11.222,11.222,0,0,0-5.09,8.826L45,229.505l.013.005-.045.026v.381l8.625,4.91Z",
    transform: "translate(-44.967 -43.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M53.625,234.8l-.027-9.526a11.218,11.218,0,0,1,5.089-8.825L347.225,49.858a3.624,3.624,0,0,1,3.571-.377l-8.513-5.228v.009a3.54,3.54,0,0,0-3.684.305L50.061,211.154a11.222,11.222,0,0,0-5.09,8.826L45,229.505l.013.005-.045.026v.381l8.625,4.91Z",
    transform: "translate(-44.967 -43.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M53.64,303.022l-.047-16.533-8.625-4.91.046,16.152h0v.367l8.625,4.924Z",
    transform: "translate(-44.967 -95.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M53.64,303.022l-.047-16.533-8.625-4.91.046,16.152h0v.367l8.625,4.924Z",
    transform: "translate(-44.967 -95.537)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.631 5.284)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M349.622,51.325c2.815-1.626,5.114-.315,5.123,2.93l.027,9.525L56.022,236.264l-.027-9.525a11.218,11.218,0,0,1,5.089-8.826Z",
    transform: "translate(-55.995 -50.627)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.193 11.745)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.62)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M405.69,71.547c1.508-.871,2.736-.171,2.741,1.562a6,6,0,0,1-2.723,4.717c-1.509.871-2.737.171-2.742-1.562A6,6,0,0,1,405.69,71.547Z",
    transform: "translate(-402.966 -71.172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.335 4.807)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M416.34,65.4c1.508-.871,2.736-.171,2.741,1.562a6,6,0,0,1-2.724,4.717c-1.508.872-2.736.172-2.741-1.562A6,6,0,0,1,416.34,65.4Z",
    transform: "translate(-413.616 -65.023)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.661)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M426.978,59.256c1.509-.871,2.736-.171,2.742,1.562A6,6,0,0,1,427,65.535c-1.509.871-2.737.171-2.742-1.562A6,6,0,0,1,426.978,59.256Z",
    transform: "translate(-424.254 -58.881)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.626 18.469)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M116.1,195.793c1.122-.648,2.164-.54,2.7.294l2.712,4.173c.536.834,1.569.958,2.7.3L354.738,67.473l.047,16.555L56.035,256.512l-.047-16.555,8.851-5.11a6.763,6.763,0,0,0,2.7-3.423l2.67-7.281a6.7,6.7,0,0,1,2.69-3.406Z",
    transform: "translate(-55.988 -67.473)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.673 35.002)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M354.8,88.6l.543,191.487a11.234,11.234,0,0,1-5.09,8.815L61.714,455.487c-2.825,1.63-5.114.315-5.123-2.919l-.543-191.487Z",
    transform: "translate(-56.048 -88.597)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "al",
    transform: "translate(8.673 35.002)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M354.8,88.6l.543,191.487a11.234,11.234,0,0,1-5.09,8.815L61.714,455.487c-2.825,1.63-5.114.315-5.123-2.919l-.543-191.487Z",
    transform: "translate(-56.048 -88.597)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.384 28.141)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.714)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M351.432,80.329c2.006-1.158,3.63-.232,3.636,2.072a7.967,7.967,0,0,1-3.613,6.268l-252.887,146c-2.006,1.158-3.639.227-3.646-2.078a7.97,7.97,0,0,1,3.622-6.263Z",
    transform: "translate(-94.922 -79.83)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 164.212)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M61.3,289.711a.349.349,0,0,1,.375-.026c.193.132.176.513-.025.852l-1.6,2.6,4.186-2.417c.285-.164.516-.033.517.284a1.13,1.13,0,0,1-.513.89l-4.186,2.416,1.605.757c.2.106.222.465.03.809a1.059,1.059,0,0,1-.376.408.393.393,0,0,1-.35.054l-2.566-1.23-.1-.1-.019-.031-.046-.206.045-.259.018-.042.092-.212,2.559-4.188A1.051,1.051,0,0,1,61.3,289.711Z",
    transform: "translate(-58.235 -289.641)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.694 158.982)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M72.773,283.029a.382.382,0,0,1,.352-.044L75.69,284.2l.1.11.027.016.038.211-.036.254-.027.058-.092.2-2.559,4.2a.992.992,0,0,1-.349.35.336.336,0,0,1-.369.022c-.194-.121-.185-.5.025-.841l1.587-2.6L69.851,288.6c-.276.16-.506.028-.508-.3a1.125,1.125,0,0,1,.5-.874l4.186-2.417-1.6-.762c-.213-.1-.223-.465-.031-.819A1.009,1.009,0,0,1,72.773,283.029Z",
    transform: "translate(-69.343 -282.959)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.876 152.93)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M83.927,276.381a2.226,2.226,0,0,1,1.731-.322l.386-.509a.947.947,0,0,1,.275-.254.415.415,0,0,1,.276-.064c.175.026.259.211.232.459l-.217,1.576a1.122,1.122,0,0,1-.219.53,1.154,1.154,0,0,1-.276.254l-.128.053-1.244.347a.287.287,0,0,1-.378-.258.986.986,0,0,1,.228-.715l.12-.164a1.6,1.6,0,0,0-.783.24,4.057,4.057,0,0,0-1.834,3.177c0,1.173.834,1.636,1.846,1.052a4.04,4.04,0,0,0,1.616-2.024A1.087,1.087,0,0,1,86,279.2a.449.449,0,0,1,.247-.069c.249.015.342.322.205.686a6.244,6.244,0,0,1-2.507,3.142c-1.574.909-2.866.182-2.871-1.636A6.308,6.308,0,0,1,83.927,276.381Z",
    transform: "translate(-81.075 -275.227)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "am",
    transform: "translate(0 164.212)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M61.3,289.711a.349.349,0,0,1,.375-.026c.193.132.176.513-.025.852l-1.6,2.6,4.186-2.417c.285-.164.516-.033.517.284a1.13,1.13,0,0,1-.513.89l-4.186,2.416,1.605.757c.2.106.222.465.03.809a1.059,1.059,0,0,1-.376.408.393.393,0,0,1-.35.054l-2.566-1.23-.1-.1-.019-.031-.046-.206.045-.259.018-.042.092-.212,2.559-4.188A1.051,1.051,0,0,1,61.3,289.711Z",
    transform: "translate(-58.235 -289.641)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "am",
    transform: "translate(8.694 158.982)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M72.773,283.029a.382.382,0,0,1,.352-.044L75.69,284.2l.1.11.027.016.038.211-.036.254-.027.058-.092.2-2.559,4.2a.992.992,0,0,1-.349.35.336.336,0,0,1-.369.022c-.194-.121-.185-.5.025-.841l1.587-2.6L69.851,288.6c-.276.16-.506.028-.508-.3a1.125,1.125,0,0,1,.5-.874l4.186-2.417-1.6-.762c-.213-.1-.223-.465-.031-.819A1.009,1.009,0,0,1,72.773,283.029Z",
    transform: "translate(-69.343 -282.959)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "am",
    transform: "translate(17.876 152.93)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M83.927,276.381a2.226,2.226,0,0,1,1.731-.322l.386-.509a.947.947,0,0,1,.275-.254.415.415,0,0,1,.276-.064c.175.026.259.211.232.459l-.217,1.576a1.122,1.122,0,0,1-.219.53,1.154,1.154,0,0,1-.276.254l-.128.053-1.244.347a.287.287,0,0,1-.378-.258.986.986,0,0,1,.228-.715l.12-.164a1.6,1.6,0,0,0-.783.24,4.057,4.057,0,0,0-1.834,3.177c0,1.173.834,1.636,1.846,1.052a4.04,4.04,0,0,0,1.616-2.024A1.087,1.087,0,0,1,86,279.2a.449.449,0,0,1,.247-.069c.249.015.342.322.205.686a6.244,6.244,0,0,1-2.507,3.142c-1.574.909-2.866.182-2.871-1.636A6.308,6.308,0,0,1,83.927,276.381Z",
    transform: "translate(-81.075 -275.227)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M352.39,78.9h0l-.047-16.555L121.822,195.436c-.027.016-.052.019-.081.034L352.375,62.313l-.027-9.525a3.537,3.537,0,0,0-1.555-3.309l0,0-8.513-5.228v.009a3.54,3.54,0,0,0-3.684.305L50.061,211.154a11.219,11.219,0,0,0-5.089,8.826L45,229.505l.013.005-.045.026v.381l.046,16.152,0,.367.541,191.12A3.593,3.593,0,0,0,47,440.794l-.005,0,.045.027.035.021,8.5,5.2c.066.042.13.085.2.121l.064.039v-.016a3.679,3.679,0,0,0,3.461-.423L347.844,279.179a11.234,11.234,0,0,0,5.09-8.815ZM54.566,444.826c-.026-.057-.038-.13-.061-.19C54.528,444.7,54.541,444.768,54.566,444.826Zm-.28-.891a5.588,5.588,0,0,1-.1-1.08A5.732,5.732,0,0,0,54.286,443.934Zm294.9-394.755c-.054,0-.113.029-.168.037C349.075,49.208,349.133,49.184,349.187,49.179Zm-.945.21a5.831,5.831,0,0,0-1.017.469A5.8,5.8,0,0,1,348.243,49.389ZM54.459,221.482a9.61,9.61,0,0,0-.861,3.79h0A9.61,9.61,0,0,1,54.459,221.482ZM53.625,234.8h0l8.9-5.138c-.028.017-.053.044-.081.06l-8.851,5.11Zm.015,16.564h0Z",
    transform: "translate(-44.967 -43.875)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.774 206.092)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "am"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M295.228,307.648c1.822-1.052,3.309-.2,3.315,1.9l.045,15.66a7.273,7.273,0,0,1-3.294,5.712L179.64,397.689c-1.822,1.052-3.309.2-3.315-1.9l-.045-15.66a7.274,7.274,0,0,1,3.293-5.712Z",
    transform: "translate(-176.28 -307.196)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.258 21.452)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 34.299)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M222.387,378.428l-.047,2.425,1.878-2.407,1.048,1.376-1.825,2.211,1.831.08-1.036,2.579-1.885-.214.06,2.343L220.362,388l.047-2.4-1.878,2.386L217.5,386.6l1.825-2.191-1.831-.1,1.018-2.568,1.885.234-.06-2.364Z",
    transform: "translate(-217.495 -378.428)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.484 29.401)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M233.227,372.169l-.047,2.426,1.884-2.41,1.048,1.376-1.83,2.215,1.837.077-1.036,2.579-1.891-.21.06,2.343-2.042,1.179.047-2.4-1.884,2.39-1.03-1.386,1.831-2.194-1.837-.1,1.018-2.568,1.891.231-.06-2.364Z",
    transform: "translate(-228.336 -372.169)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.975 24.499)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M244.075,365.906l-.047,2.426,1.878-2.407,1.048,1.376-1.831,2.215,1.837.077-1.036,2.579-1.885-.214.06,2.343-2.048,1.182.047-2.4-1.878,2.386-1.03-1.386,1.825-2.191-1.831-.1,1.018-2.568,1.885.234-.06-2.364Z",
    transform: "translate(-239.183 -365.906)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.459 19.601)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M254.915,359.648l-.047,2.425,1.884-2.41,1.042,1.379-1.825,2.211,1.831.081-1.03,2.575-1.891-.21.06,2.343-2.048,1.182.047-2.4-1.878,2.386-1.03-1.386,1.83-2.194-1.837-.1,1.018-2.568,1.885.234-.06-2.364Z",
    transform: "translate(-250.024 -359.648)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.949 14.702)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M265.757,353.389l-.047,2.426,1.884-2.41,1.048,1.376-1.831,2.215,1.837.077-1.036,2.579-1.891-.21.06,2.343-2.042,1.179.047-2.4-1.884,2.39-1.024-1.389,1.825-2.191-1.831-.1,1.013-2.565,1.891.231-.06-2.364Z",
    transform: "translate(-260.871 -353.389)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.433 9.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M276.6,347.126l-.047,2.426,1.878-2.407,1.047,1.375-1.824,2.212,1.831.08-1.036,2.579-1.885-.214.06,2.343-2.048,1.182.047-2.4-1.878,2.386-1.03-1.386,1.825-2.191-1.831-.1,1.018-2.568,1.885.234-.06-2.364Z",
    transform: "translate(-271.712 -347.126)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.918 4.902)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M287.443,340.867l-.047,2.426,1.884-2.41,1.047,1.376-1.83,2.215,1.837.077-1.036,2.579-1.891-.21.06,2.343-2.042,1.179.047-2.4-1.884,2.39-1.03-1.386,1.831-2.194-1.837-.1,1.018-2.568,1.891.231-.06-2.364Z",
    transform: "translate(-282.552 -340.867)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.408)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M298.291,334.6l-.047,2.426,1.878-2.407L301.17,336l-1.825,2.212,1.831.08-1.036,2.579-1.885-.214.06,2.343-2.048,1.182.047-2.4-1.878,2.386-1.03-1.386,1.825-2.191-1.831-.1,1.018-2.568,1.885.234-.06-2.364Z",
    transform: "translate(-293.4 -334.604)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.942 63.291)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M194.429,402.8a.9.9,0,0,0-.615.139,2.418,2.418,0,0,0-1.1,1.9,1.188,1.188,0,0,0,.041.312.579.579,0,0,0,.453.446c.019,0,.034.014.052.016l-.324,2.805,1.777-1.025-.339-2.423a2.662,2.662,0,0,0,.392-.679,2,2,0,0,0,.148-.723,1.044,1.044,0,0,0-.088-.442A.553.553,0,0,0,194.429,402.8Z",
    transform: "translate(-187.794 -391.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M186.427,403.242l.023,7.9,12.028-6.944-.023-7.9Zm6.975-.363a2.662,2.662,0,0,1-.392.679l.339,2.423-1.777,1.025h0l.324-2.805c-.019,0-.034-.013-.052-.016a.579.579,0,0,1-.453-.446,1.188,1.188,0,0,1-.041-.312,2.418,2.418,0,0,1,1.1-1.9.9.9,0,0,1,.615-.139.553.553,0,0,1,.4.326,1.044,1.044,0,0,1,.088.442A2,2,0,0,1,193.4,402.879Z",
    transform: "translate(-186.427 -389.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M189.471,399.9l-.011-3.805a7.3,7.3,0,0,1,3.308-5.726c1.828-1.056,3.321-.205,3.327,1.9l.007,2.523,1.437-.83-.007-2.523c-.009-3.012-2.148-4.231-4.769-2.717a10.456,10.456,0,0,0-4.738,8.206l.011,3.805Z",
    transform: "translate(-186.774 -388.062)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.186 3.661)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M197.046,397.53l-1.258.726a.4.4,0,0,0-.179.31c0,.115.08.16.18.1l1.259-.726a.392.392,0,0,0,.178-.31C197.226,397.52,197.145,397.473,197.046,397.53Z",
    transform: "translate(-195.609 -393.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M197.491,396.524c.05-.127.02-.236-.067-.242l-1.09-.095a.156.156,0,0,0-.091.024.387.387,0,0,0-.155.192c-.05.13-.019.236.067.244l1.09.095a.154.154,0,0,0,.09-.023A.389.389,0,0,0,197.491,396.524Z",
    transform: "translate(-195.708 -393.489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M200.826,394.53a.338.338,0,0,0,.09-.081L202,393.1a.3.3,0,0,0,.066-.321c-.034-.046-.094-.048-.156-.012a.327.327,0,0,0-.09.081l-1.088,1.352a.3.3,0,0,0-.064.318C200.7,394.563,200.764,394.565,200.826,394.53Z",
    transform: "translate(-196.704 -392.739)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M202.333,394.478l-1.259.726a.4.4,0,0,0-.178.31c0,.115.081.16.18.1l1.258-.726a.4.4,0,0,0,.179-.31C202.512,394.467,202.432,394.421,202.333,394.478Z",
    transform: "translate(-196.758 -393.112)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "am",
    transform: "translate(138.92 256.13)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M285.719,371.375c.969-.573,1.759-.111,1.763,1.033l.023,8.533a3.982,3.982,0,0,1-1.752,3.112l-61.5,36.384c-.969.573-1.76.111-1.763-1.033l-.023-8.533a3.982,3.982,0,0,1,1.752-3.112Z",
    transform: "translate(-222.463 -371.129)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.726 142.732)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.967 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M241.531,246.857a5.031,5.031,0,0,1-2.542-.664c-1.782-1.029-2.762-3.066-2.762-5.735a16.461,16.461,0,0,1,7.55-13.074v0c2.3-1.334,4.551-1.5,6.345-.472s2.762,3.066,2.762,5.735a16.466,16.466,0,0,1-7.546,13.073A7.7,7.7,0,0,1,241.531,246.857Z",
    transform: "translate(-236.227 -226.242)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19.829)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M253.638,252.546c-2.6-1.5-5.9-1.251-9.306.715l-3.837,2.208c-6.667,3.859-11.892,12.912-11.892,20.608v3.985c3.764,2.093,8.905,1.735,14.594-1.546s10.83-8.864,14.594-15.289V261.3C257.791,257.257,256.287,254.071,253.638,252.546Z",
    transform: "translate(-228.603 -251.577)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.752 11.745)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M425.932,65.91a1.72,1.72,0,0,1-.867-.226,2.124,2.124,0,0,1-.942-1.955,5.612,5.612,0,0,1,2.574-4.458v0a1.927,1.927,0,0,1,3.106,1.795,5.615,5.615,0,0,1-2.573,4.458A2.632,2.632,0,0,1,425.932,65.91Z",
    transform: "translate(-424.123 -58.881)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.422 16.552)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M415.288,72.052a1.72,1.72,0,0,1-.867-.226,2.124,2.124,0,0,1-.942-1.955,5.612,5.612,0,0,1,2.574-4.458v0a1.927,1.927,0,0,1,3.106,1.795,5.615,5.615,0,0,1-2.573,4.458A2.624,2.624,0,0,1,415.288,72.052Z",
    transform: "translate(-413.479 -65.023)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.086 21.364)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M404.638,78.2a1.719,1.719,0,0,1-.867-.226,2.125,2.125,0,0,1-.942-1.956,5.612,5.612,0,0,1,2.574-4.457v0a1.927,1.927,0,0,1,3.106,1.795,5.616,5.616,0,0,1-2.573,4.458A2.632,2.632,0,0,1,404.638,78.2Z",
    transform: "translate(-402.829 -71.172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.774 167.929)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "am",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M295.228,258.888c1.822-1.052,3.309-.2,3.315,1.9l.045,15.66a7.273,7.273,0,0,1-3.294,5.712L179.64,348.928c-1.822,1.052-3.309.2-3.315-1.9l-.045-15.66a7.274,7.274,0,0,1,3.293-5.712Z",
    transform: "translate(-176.28 -258.436)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.315 64.429)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M190.211,348.645a1.924,1.924,0,0,1-.973-.254,2.384,2.384,0,0,1-1.057-2.195,6.3,6.3,0,0,1,2.889-5v0a2.163,2.163,0,0,1,3.485,2.014,6.3,6.3,0,0,1-2.888,5A2.946,2.946,0,0,1,190.211,348.645Z",
    transform: "translate(-188.182 -340.756)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.031 72.017)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M194.845,350.822a3.494,3.494,0,0,0-3.561.273l-1.469.845a9.941,9.941,0,0,0-4.55,7.887v1.525c1.44.8,3.408.664,5.585-.592a16.232,16.232,0,0,0,5.584-5.85v-.737A3.675,3.675,0,0,0,194.845,350.822Z",
    transform: "translate(-185.264 -350.451)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.288 59.699)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M214.453,342.6a1.927,1.927,0,0,1-.974-.254,2.384,2.384,0,0,1-1.057-2.195,6.3,6.3,0,0,1,2.889-5v0a2.162,2.162,0,0,1,3.485,2.014,6.3,6.3,0,0,1-2.887,5A2.948,2.948,0,0,1,214.453,342.6Z",
    transform: "translate(-212.423 -334.712)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.245 53.438)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M228.453,334.6a1.927,1.927,0,0,1-.974-.254,2.384,2.384,0,0,1-1.057-2.195,6.3,6.3,0,0,1,2.889-5v0a2.162,2.162,0,0,1,3.485,2.014,6.3,6.3,0,0,1-2.887,5A2.948,2.948,0,0,1,228.453,334.6Z",
    transform: "translate(-226.423 -326.712)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.517 46.792)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M241.576,326.109a1.935,1.935,0,0,1-.973-.254,2.385,2.385,0,0,1-1.057-2.2,6.3,6.3,0,0,1,2.889-5v0a2.163,2.163,0,0,1,3.485,2.015,6.3,6.3,0,0,1-2.887,5A2.948,2.948,0,0,1,241.576,326.109Z",
    transform: "translate(-239.547 -318.221)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.181 40.293)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M255.2,317.806a1.928,1.928,0,0,1-.974-.254,2.384,2.384,0,0,1-1.057-2.195,6.3,6.3,0,0,1,2.889-5v0a2.162,2.162,0,0,1,3.485,2.015,6.3,6.3,0,0,1-2.887,5A2.948,2.948,0,0,1,255.2,317.806Z",
    transform: "translate(-253.173 -309.917)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.139 34.031)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M269.2,309.806a1.928,1.928,0,0,1-.974-.254,2.384,2.384,0,0,1-1.057-2.195,6.3,6.3,0,0,1,2.889-5v0a2.162,2.162,0,0,1,3.485,2.015,6.3,6.3,0,0,1-2.887,5A2.948,2.948,0,0,1,269.2,309.806Z",
    transform: "translate(-267.173 -301.917)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.41 27.386)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M282.326,301.315a1.926,1.926,0,0,1-.973-.254,2.385,2.385,0,0,1-1.057-2.195,6.3,6.3,0,0,1,2.889-5v0a2.162,2.162,0,0,1,3.485,2.014,6.3,6.3,0,0,1-2.887,5A2.949,2.949,0,0,1,282.326,301.315Z",
    transform: "translate(-280.297 -293.426)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolLogin);
export default __webpack_public_path__ + "static/media/school_login.64b29831408a5ef32d727dad3218a52b.svg";
export { ForwardRef as ReactComponent };